import React, { useState, useEffect } from "react";
import "../styles/Ozgecmisim.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import UyariPopup from "../components/UyariPopup";
import CropperPopup from "../components/CropperPopup";

const steps = ["Genel Bilgiler", "Deneyim", "Eğitim", "Yetkinlikler", "Profil Ön İzleme"];

const Ozgecmisim = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [currentStep, setCurrentStep] = useState(0);
  const [showKvkkModal, setShowKvkkModal] = useState(false);
  const [warning, setWarning] = useState("");
  const [showDeneyimForm, setShowDeneyimForm] = useState(false);
  const [noExperience, setNoExperience] = useState(false);
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [deneyimler, setDeneyimler] = useState([]);
  const [showEgitimForm, setShowEgitimForm] = useState(false);
  const [egitimSeviyesi, setEgitimSeviyesi] = useState(""); /*  const [egitimSeviyesi, setEgitimSeviyesi] = useState("Lise");*/
  const [liseTerk, setLiseTerk] = useState(false);
  const [duzenleMode, setDuzenleMode] = useState(false);
  const [duzenlenecekDeneyim, setDuzenlenecekDeneyim] = useState(null);
  const [kategoriListesi, setKategoriListesi] = useState([]);
  const [egitimler, setEgitimler] = useState([]);
  const [duzenleEgitimMode, setDuzenleEgitimMode] = useState(false);
  const [duzenlenecekEgitim, setDuzenlenecekEgitim] = useState(null);
  const [egitimDurumuListesi, setEgitimDurumuListesi] = useState([]);
  const [okulListesi, setOkulListesi] = useState([]);
  const [egitimTuruListesi, setEgitimTuruListesi] = useState([]);
  const [silID, setSilID] = useState(null);
  const [silinecekEgitimID, setSilinecekEgitimID] = useState(null);
  const [showEgitimDeleteConfirm, setShowEgitimDeleteConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showDilPopup, setShowDilPopup] = useState(false);
  const [dilForm, setDilForm] = useState({ dilID: "", okuma: "", yazma: "", konusma: "", dinleme: "" });
  const [dilListesi, setDilListesi] = useState([]);
  const [uyariGosterDil, setUyariGosterDil] = useState("");
  const [dilSeviyeListesi, setDilSeviyeListesi] = useState([]);
  const [noReference, setNoReference] = useState(false);
  const [eklenenDiller, setEklenenDiller] = useState([]);
  const [duzenlenecekDil, setDuzenlenecekDil] = useState(null);
  const [showSertifikaPopup, setShowSertifikaPopup] = useState(false);
  const [sertifikaForm, setSertifikaForm] = useState({ ad: "", aciklama: "" });
  const [eklenenSertifikalar, setEklenenSertifikalar] = useState([]);
  const [uyariGoster, setUyariGoster] = useState(false);
  const [smsCode, setSmsCode] = useState("");
  const [dogrulukBeyaniOnaylandi, setDogrulukBeyaniOnaylandi] = useState(false);
  const [smsKod, setSmsKod] = useState("");
  const [telefonDogrulandi, setTelefonDogrulandi] = useState(false);
  const [profilUyarisi, setProfilUyarisi] = useState("");
  const [smsKodGonderildi, setSmsKodGonderildi] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showDilDeleteConfirm, setShowDilDeleteConfirm] = useState(false);
  const [showSertifikaDeleteConfirm, setShowSertifikaDeleteConfirm] = useState(false);
  const navigate = useNavigate();
  const [referanslar, setReferanslar] = useState([]);
  const [showMaskedData, setShowMaskedData] = useState(false);
  const [showReferansPopup, setShowReferansPopup] = useState(false);
  const [kimlikDogrulandi, setKimlikDogrulandi] = useState(false);
  const [uyariMesaj, setUyariMesaj] = useState("");
  const [uyariBaslik, setUyariBaslik] = useState("");
  const [uyariTipi, setUyariTipi] = useState("info");
  const [uyariAcik, setUyariAcik] = useState(false);
  const [referansUyari, setReferansUyari] = useState("");
  const [referansKaydetClicked, setReferansKaydetClicked] = useState(false);
  const [duzenlenecekSertifika, setDuzenlenecekSertifika] = useState(null);
  const [showReferansDeleteConfirm, setShowReferansDeleteConfirm] = useState(false);
  const [silinecekReferansID, setSilinecekReferansID] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [cropImageUrl, setCropImageUrl] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [showFullPhoto, setShowFullPhoto] = useState(false);
  const token = localStorage.getItem("token");
  const [kanGrubuOptions, setKanGrubuOptions] = useState([]);
  const [highlightKanGrubu, setHighlightKanGrubu] = useState(false);
  const [fotoKaydediliyor, setFotoKaydediliyor] = useState(false);

  const fetchPhoto = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      const imageUrl = URL.createObjectURL(response.data);
      setProfilePhoto(imageUrl);
    } catch (err) {
      console.error("Profil fotoğrafı alınamadı:", err);
    }
  };

  useEffect(() => {
    const shouldFocus = sessionStorage.getItem("focusKanGrubu");

    if (shouldFocus === "true") {
      setHighlightKanGrubu(true);

      setTimeout(() => {
        const el = document.getElementById("kanGrubuAlan");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 300);

      sessionStorage.removeItem("focusKanGrubu");
    }
  }, []);
  useEffect(() => {
    if (highlightKanGrubu) {
      const timer = setTimeout(() => {
        setHighlightKanGrubu(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [highlightKanGrubu]);

  useEffect(() => {
    fetchPhoto();
  }, []);

  const handlePhotoUpload = (e) => {
    if (fotoKaydediliyor) {
      setWarning("Profil fotoğrafı kaydediliyor, lütfen bekleyin.");
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setWarning("⚠️ Lütfen geçerli bir görsel dosyası yükleyin.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setWarning("⚠️ Fotoğraf boyutu en fazla 5 MB olabilir.");
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      if (img.width < 200 || img.height < 200) {
        setWarning("⚠️ Lütfen daha net bir profil fotoğrafı yükleyin.");
        URL.revokeObjectURL(objectUrl);
        return;
      }

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 80;
      canvas.height = 80;
      ctx.drawImage(img, 0, 0, 80, 80);

      const pixels = ctx.getImageData(0, 0, 80, 80).data;
      let brightnessValues = [];

      for (let i = 0; i < pixels.length; i += 4) {
        const r = pixels[i];
        const g = pixels[i + 1];
        const b = pixels[i + 2];

        const brightness = (r + g + b) / 3;
        brightnessValues.push(brightness);
      }

      const average =
        brightnessValues.reduce((sum, val) => sum + val, 0) / brightnessValues.length;

      const variance =
        brightnessValues.reduce((sum, val) => sum + Math.pow(val - average, 2), 0) /
        brightnessValues.length;

      if (variance < 20) {
        setWarning("⚠️ Boş, düz renk veya geçersiz fotoğraf yüklenemez.");
        URL.revokeObjectURL(objectUrl);
        return;
      }

      setWarning("");
      const reader = new FileReader();
      reader.onloadend = () => {
        setCropImageUrl(reader.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);

      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };

  const gosterUyari = (mesaj, baslik = "", tip = "info") => {
    setUyariMesaj(mesaj);
    setUyariBaslik(baslik);
    setUyariTipi(tip);
    setUyariAcik(true);
  };

  const handleReferansSilOnayla = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/Referans/sil/${silinecekReferansID}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });

      setReferanslar(prev => prev.filter(r => r.referansId !== silinecekReferansID));
      gosterUyari("Referans başarıyla silindi.", "✅ Silindi", "success");

    } catch (err) {
      console.error("❌ Referans silme hatası:", err);
      gosterUyari("Referans silinemedi.", "❌ Hata", "error");
    }

    setShowReferansDeleteConfirm(false);
    setSilinecekReferansID(null);
  };


  const [referansForm, setReferansForm] = useState({
    referansId: 0,
    referansAdi: "",
    referansNumara: "",
    referansAciklama: "",
    profosyonelRefmi: false,
    cvid: 0,
    status: true,
    referansFirmaKurum: "",
    referansPozisyon: "",
    referansDerece: "",
    referansMail: ""
  });

  const handleVatandaslikKontrol = async () => {
    const dogumYili = formData.dogumTarihi.split("-")[0];

    const payload = {
      tc: formData.tc,
      ad: formData.adi?.trim().toUpperCase(),
      soyad: formData.soyadi?.trim().toUpperCase(),
      dogumYili: parseInt(dogumYili),
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/VatandaslikKontrol`, payload);

      if (response.status === 200) {
        console.log("Kimlik doğrulandı.");
        // Devam et
        return true;
      }
    } catch (error) {
      console.error("Kimlik doğrulama hatası:", error);
      alert("Kimlik bilgileri doğrulanamadı. Lütfen T.C. Kimlik No, Ad, Soyad ve Doğum Yılı'nı kontrol edin.");
      return false;
    }
  };


  const maskPhone = (phone) => {
    if (!phone) return "";
    return phone.replace(/\d(?=\d{2})/g, "*");
  };

  const maskEmail = (email) => {
    if (!email) return "";
    const [name, domain] = email.split("@");
    const maskedName = name.length > 3 ? name.slice(0, 2) + "*".repeat(name.length - 2) : "*".repeat(name.length);
    return `${maskedName}@${domain}`;
  };

  const fetchReferanslar = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Referans/getirhepsi`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const data = response.data?.$values || [];
      setReferanslar(response.data?.$values || []);
    } catch (err) {
      console.error("❌ Referanslar alınamadı:", err);
      gosterUyari("Referanslar getirilirken hata oluştu.", "❌ Hata", "error");
    }
  };
  useEffect(() => {
    if (referansKaydetClicked && referansUyari) {
      const timer = setTimeout(() => {
        setReferansUyari(""); // Uyarı yazısını kaldır
      }, 3000); // 3 saniye sonra gizle
      return () => clearTimeout(timer); // Bileşen unmount olursa temizle
    }
  }, [referansKaydetClicked, referansUyari]);


  useEffect(() => {
    const token = localStorage.getItem("token");

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Referans/getirhepsi`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setReferanslar(res.data.$values || []);
      })
      .catch((err) => {
        console.error("Referanslar alınamadı:", err);
      });
  }, []);

  const handleReferansKaydet = async () => {
    setReferansKaydetClicked(true);

    if (!referansForm.referansMail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(referansForm.referansMail)) {
      setReferansUyari("⚠️ Lütfen geçerli bir e-posta adresi girin. (örn: ad@domain.com)");
      return;
    }

    try {
      const payload = {
        referansId: referansForm.referansId || 0,
        referansAdi: referansForm.referansAdi,
        referansNumara: referansForm.referansNumara,
        referansAciklama: referansForm.referansAciklama,
        profosyonelRefmi: referansForm.profosyonelRefmi,
        cvid: 0,
        status: true,
        referansFirmaKurum: referansForm.referansFirmaKurum,
        referansPozisyon: referansForm.referansPozisyon,
        referansDerece: referansForm.referansDerece,
        referansMail: referansForm.referansMail,
      };

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Referans/ekle`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      gosterUyari("Referans başarıyla kaydedildi.", "✅ Başarılı", "success");
      setShowReferansPopup(false);
      setReferansForm({
        referansId: 0,
        referansAdi: "",
        referansNumara: "",
        referansAciklama: "",
        profosyonelRefmi: false,
        cvid: 0,
        status: true,
        referansFirmaKurum: "",
        referansPozisyon: "",
        referansDerece: "",
        referansMail: "",
      });
      setShowReferansPopup(false);
      await fetchReferanslar();
    } catch (err) {
      console.error("❌ Referans ekleme hatası:", err);
      gosterUyari("Referans eklenirken bir hata oluştu.", "❌ Hata", "error");
    }
  };

  useEffect(() => {
    if (currentStep === 1) {
      fetchReferanslar();
    }
  }, [currentStep]);

  const handleReferansEkle = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Referans/ekle`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...referansForm,
          referansId: 0,
          cvid: 0,
          status: true
        }),
      });

      if (res.ok) {
        gosterUyari("Referans başarıyla eklendi.", "✅ Başarılı", "success");

        setNoReference(false);
        setShowReferansPopup(false);
        fetchReferanslar();
      } else {
        gosterUyari("Referans eklenemedi.", "❌ Hata", "error");
      }
    } catch (err) {
      console.error("Ekleme hatası:", err);
    }
  };

  const handleDeleteReferans = (id) => {
    setSilinecekEgitimID(id);
    setShowEgitimDeleteConfirm(true);
  };


  const handleReferansGuncelle = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Referans/guncelle`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...referansForm, cvid: 0, status: true }),
      });

      if (res.ok) {
        gosterUyari("Referans güncellendi.", "✅ Başarılı", "success");
        setShowReferansPopup(false);
        fetchReferanslar();
      } else {
        gosterUyari("Referans güncellenemedi.", "❌ Hata", "error");
      }
    } catch (err) {
      console.error("Güncelleme hatası:", err);
    }
  };

  const getIlAdi = (id) => iller.find(i => i.kullaniciIlID === id)?.kullaniciIlAdi || "-";
  const getIlceAdi = (id) => ilceler.find(i => i.kisiIlceId === id)?.kisiIlceAdi || "-";
  const getOkulAdi = (id) => okulListesi.find(o => o.egitimLisansID === id)?.egitimLisansAdi || "-";
  const getBolumAdi = (id) => bolumListesi.find(b => b.egitimBolumID === id)?.egitimBolumAdi || "-";
  const getEgitimDurumAdi = (id) => egitimDurumuListesi.find(e => e.egitimDurumuID === id)?.egitimDurumAdi || "-";
  const getDilAdi = (id) => dilListesi.find(d => d.dilId === id)?.dilAdi || "-";
  const getDilSeviyeAdi = (id) => dilSeviyeListesi.find(s => s.dilSeviyeId === id)?.dilSeviyeAdi || "-";
  const diller = eklenenDiller;
  const sertifikalar = eklenenSertifikalar;


  const handleDilSilOnayla = () => {
    // Buraya API çağrınızı veya silme işlemini yazın
    console.log("Dil silindi");
    setShowDilDeleteConfirm(false);
  };

  const handleSertifikaSilOnayla = () => {
    // Buraya API çağrınızı veya silme işlemini yazın
    console.log("Sertifika silindi");
    setShowSertifikaDeleteConfirm(false);
  };
  useEffect(() => {
    if (currentStep === 4) {
      setFormData((prev) => ({ ...prev, DogrulukBeyani: false }));
      setDogrulukBeyaniOnaylandi(false);
    }
  }, [currentStep]);



  useEffect(() => {
    const checkTelefonDogrulandiMi = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/issmsverified`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        console.log("📞 SMS doğrulama durumu:", res.data);

        if (res.data?.isVerified === true) {
          setTelefonDogrulandi(true);
        }
      } catch (err) {
        console.error("❌ Telefon doğrulama durumu alınamadı:", err);
      }
    };

    if (currentStep === 4) {
      checkTelefonDogrulandiMi();
    }
  }, [currentStep]);

  const handleSendSmsCode = async () => {
    if (!formData.DogrulukBeyani) {
      setProfilUyarisi("⚠️ Lütfen önce doğruluk beyanını onaylayın.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/sendsmscode`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("✅ SMS kodu gönderildi.");
    } catch (err) {
      console.error("❌ SMS gönderme hatası:", err);
      alert("❌ SMS gönderilemedi.");
    }
  };


  const handleVerifySmsCode = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/confirmsmscode`,
        { code: smsCode },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }

      );
      if (response.data.isAccepted) {
        gosterUyari("SMS doğrulama başarılı!", "✅ Başarılı", "success");
      } else {
        alert("❌ Kod yanlış veya onaylanmadı.");
      }
    } catch (err) {
      console.error("❌ Kod doğrulama hatası:", err);
      gosterUyari("Kod yanlış veya onaylanmadı.", "❌ Uyarı", "error");
    }
  };

  useEffect(() => {
    const checkDogrulukBeyani = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/dogrulukbeyan`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setDogrulukBeyaniOnaylandi(response.data.isAccepted === true);
      } catch (err) {
        console.error("Doğruluk beyanı kontrolü hatası:", err);
      }
    };

    if (currentStep === 4) {
      checkDogrulukBeyani();
    }
  }, [currentStep]);



  useEffect(() => {
    const fetchDiller = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Dil/getirhepsi`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        setDilListesi(res.data.$values || []);
      } catch (err) {
        console.error("Dil verisi alınamadı:", err);
      }
    };

    const fetchSeviyeler = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/DilSeviye/getirhepsi`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        setDilSeviyeListesi(res.data.$values || []);
      } catch (err) {
        console.error("Seviye verisi alınamadı:", err);
      }
    };

    fetchDiller();
    fetchSeviyeler();
  }, []);


  useEffect(() => {
    const fetchSertifikalar = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Sertifika/getirhepsi`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        setEklenenSertifikalar(response.data.$values || []);
      } catch (err) {
        console.error("❌ Sertifikalar alınamadı:", err);
      }
    };

    if (currentStep === 3) {
      fetchSertifikalar();
    }
  }, [currentStep]);

  const fetchSertifikalar = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Sertifika/getirhepsi`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setEklenenSertifikalar(response.data.$values || []);
    } catch (err) {
      console.error("❌ Sertifikalar alınamadı:", err);
    }
  };

  const handleAddSertifika = async () => {
    if (!sertifikaForm.ad || !sertifikaForm.aciklama) {
      alert("Tüm alanları doldurun!");
      return;
    }

    const payload = {
      sertifikaID: duzenlenecekSertifika?.sertifikaID || 0,
      sertifikaAdi: sertifikaForm.ad,
      sertifikaAciklama: sertifikaForm.aciklama,
      status: true,
      cvid: 0,
    };

    const url = duzenlenecekSertifika
      ? `${process.env.REACT_APP_API_BASE_URL}/api/Sertifika/guncelle`
      : `${process.env.REACT_APP_API_BASE_URL}/api/Sertifika/ekle`;

    const method = duzenlenecekSertifika ? "put" : "post";

    try {
      await axios[method](url, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      await fetchSertifikalar();
      setSertifikaForm({ ad: "", aciklama: "" });
      setDuzenlenecekSertifika(null);
      setShowSertifikaPopup(false);

      gosterUyari(
        duzenlenecekSertifika ? "Sertifika güncellendi!" : "Sertifika eklendi!",
        "✅ Başarılı",
        "success"
      );
    } catch (err) {
      console.error("❌ Sertifika kayıt hatası:", err);
      gosterUyari("Sertifika eklenemedi/güncellenemedi.", "❌ Hata", "error");
    }
  };


  const handleDeleteSertifika = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/Sertifika/sil/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      setEklenenSertifikalar((prev) => prev.filter((s) => s.sertifikaID !== id));
      gosterUyari("Sertifika başarıyla silindi.", "✅ Silindi", "success");
    } catch (err) {
      console.error("Sertifika silme hatası:", err);
      gosterUyari("Sertifika silinemedi.", "❌ Hata", "error");
    }
  };

  useEffect(() => {
    const fetchKullaniciDilleri = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/DilKullanici/dilgetirhepsi`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        console.log("📥 Gelen Dil Verisi:", res.data);
        setEklenenDiller(res.data.$values || []);
      } catch (err) {
        console.error("Dil verisi alınamadı:", err);
      }
    };

    if (currentStep === 3 || currentStep === 4) {
      fetchKullaniciDilleri();
    }
  }, [currentStep]);

  const getDilAdiById = (id) => {
    const dil = dilListesi.find((x) => x.dilId === id);
    return dil ? dil.dilAdi : "";
  };

  const getSeviyeAdiById = (id) => {
    const seviye = dilSeviyeListesi.find((x) => x.dilSeviyeId === id);
    return seviye ? seviye.dilSeviyeAdi : "";
  };

  const handleAddDil = async () => {
    const { dilID, okuma, yazma, konusma, dinleme } = dilForm;

    if (!dilID || !okuma || !yazma || !konusma || !dinleme) {
      setUyariGosterDil("⚠️ Lütfen tüm dil alanlarını doldurun.");
      return;
    }

    setUyariGosterDil(""); // eski uyarıyı sıfırla

    const payload = {
      dilKullaniciId: duzenlenecekDil?.dilKullaniciId || 0,
      cvid: 0,
      dilId: parseInt(dilID),
      dilSeviyeId: 1,
      dilAdi: "-",
      seviyeAdi: "-",
      konusma,
      dinleme,
      okuma,
      yazma
    };

    const url = duzenlenecekDil
      ? `${process.env.REACT_APP_API_BASE_URL}/api/DilKullanici/dilguncelle`
      : `${process.env.REACT_APP_API_BASE_URL}/api/DilKullanici/dilekle`;

    const method = duzenlenecekDil ? "put" : "post";

    try {
      const response = await axios[method](url, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json"
        }
      });

      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/DilKullanici/dilgetirhepsi`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });

      setEklenenDiller(res.data.$values || []);
      setDilForm({ dilID: "", okuma: "", yazma: "", konusma: "", dinleme: "" });
      setDuzenlenecekDil(null);
      setShowDilPopup(false);
      setUyariGosterDil("");
    } catch (err) {
      console.error("❌ API Hatası:", err);
      setUyariGosterDil("❌ Dil ekleme sırasında hata oluştu.");
    }
  };

  const handleDeleteDil = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/DilKullanici/dilsil/${silID}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      setEklenenDiller((prev) => prev.filter((d) => d.dilKullaniciId !== silID));
      gosterUyari("Dil başarıyla silindi.", "✅ Silindi", "success");
      setShowDilDeleteConfirm(false);
    } catch (err) {
      console.error("Dil silme hatası:", err);
      gosterUyari("Dil silinemedi.", "❌ Hata", "error");
    }
  };

  const fetchOkullar = async (setOkulListesi) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/EgitimLisans/getirhepsi`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await response.json();
      setOkulListesi(data.$values || []);
    } catch (error) {
      console.error("Okul verisi alınamadı:", error);
    }
  };

  const fetchBolumler = async (setBolumListesi) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/EgitimBolum/getirhepsi`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await response.json();
      setBolumListesi(data.$values || []);
    } catch (error) {
      console.error("Bölüm verisi alınamadı:", error);
    }
  };

  const fetchEgitimDurumlari = async (setEgitimDurumuListesi) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/EgitimDurumu/getirhepsi`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      const data = await response.json();
      setEgitimDurumuListesi(data.$values || []);
    } catch (error) {
      console.error("Eğitim durumu verisi alınamadı:", error);
    }
  };

  useEffect(() => {
    fetchEgitimDurumlari(setEgitimDurumuListesi);
  }, []);

  const liseEklendi = egitimler.some(e => e.egitimKategoriID === 1); // 1 = Lise

  const [egitimForm, setEgitimForm] = useState({
    okul: "",
    ulke: "",
    bolum: "",
    ogrenimDurumu: "Mezun",
    bitisAy: "",
    bitisYil: "",
    egitimTuru: "",
    degisimProgrami: false
  });

  const egitimEkle = async () => {
    const token = localStorage.getItem("token");
    const kategoriID = kategoriListesi.find(
      (k) => k.egitimKategoriAdi === egitimSeviyesi
    )?.egitimKategoriID;

    if (!kategoriID) {
      console.error("⚠️ Eğitim kategorisi eşleşmedi:", egitimSeviyesi);
      alert("❌ Seçilen eğitim seviyesi bulunamadı!");
      return;
    }

    const durumID = {
      "Mezun": 1,
      "Öğrenci": 2,
      "Terk": 3,
      "Devam Ediyor": 2
    }[egitimForm.egitimDurumu];

    const turID = parseInt(egitimForm.egitimTuru);

    const formatDateToISOString = (year, monthName, day) => {
      const monthIndex = [
        "", "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
      ].indexOf(monthName);
      if (monthIndex === -1) return null;
      const date = new Date(year, monthIndex, day);
      return date.toISOString();
    };

    const formatMonthToISOString = (monthStr) => {
      return monthStr ? new Date(`${monthStr}`).toISOString() : null;
    };

    const bitisTarihiISO = formatDateToISOString(
      egitimForm.bitisYil,
      egitimForm.bitisAy,
      1
    );


    const ortakPayload = {
      yabanciOkul: "",
      yabanciBolum: "",
      egitimKategoriID: kategoriID,
      egitimTuruID: turID,
      egitimDurumuID: durumID,
      bitisTarihi: bitisTarihiISO,
    };

    const payload = egitimSeviyesi === "Lise"
      ? {
        ...ortakPayload,
        egitimID: duzenleEgitimMode && duzenlenecekEgitim ? duzenlenecekEgitim.egitimID : 0,
        egitimLise: egitimForm.okul,
        egitimLiseBolum: egitimForm.bolum,
        bitisTarihi: bitisTarihiISO,
      }
      : {
        ...ortakPayload,
        egitimID: duzenleEgitimMode && duzenlenecekEgitim ? duzenlenecekEgitim.egitimID : 0,
        egitimLisansID: Number(egitimForm.okul),
        egitimBolumID: Number(egitimForm.bolum),
        bitisTarihi: bitisTarihiISO,
      };

    try {
      const url = duzenleEgitimMode
        ? `${process.env.REACT_APP_API_BASE_URL}/api/Egitim/guncelle/${payload.egitimID}`
        : `${process.env.REACT_APP_API_BASE_URL}/api/Egitim/ekle`;

      const method = duzenleEgitimMode ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });


      if (!response.ok) throw new Error("Kayıt işlemi başarısız.");

      gosterUyari("Deneyim başarıyla güncellendi!", "✅ Başarılı", "success"); setEgitimForm({});
      setEgitimSeviyesi(null);
      setShowEgitimForm(false);
      setDuzenleEgitimMode(false);
      setDuzenlenecekEgitim(null);

      // Güncel listeyi çek
      const updatedList = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Egitim/benimegitimlerim`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log("🎓 Güncellenmiş Eğitim Listesi:", updatedList.data);
      setEgitimler(updatedList.data.$values || []);

    } catch (err) {
      console.error("Eğitim kayıt/güncelleme hatası:", err);
      gosterUyari("Deneyim eklenirken/güncellenirken hata oluştu.", "❌ Hata", "error");
    }
  };

  const getOkulAdiByID = (id) => okulListesi.find(x => x.egitimLisansID === id)?.egitimLisansAdi || "-";
  const getBolumAdiByID = (id) => bolumListesi.find(x => x.egitimBolumID === id)?.egitimBolumAdi || "-";
  const getEgitimTuruAdiByID = (id) => egitimTuruListesi.find((t) => t.egitimTuruID === id)?.egitimTuruAdi || "-";
  const getEgitimDurumAdiByID = (id) => egitimDurumuListesi.find(x => x.egitimDurumuID === id)?.egitimDurumAdi || "-";

  const [bolumListesi, setBolumListesi] = useState([]);

  const fetchKategoriler = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/EgitimKategori/getirhepsi`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      const data = await res.json();
      setKategoriListesi(data.$values || []);
    } catch (err) {
      console.error("Kategori listesi alınamadı:", err);
    }
  };

  const getDurumAdi = (id) => {
    const map = {
      1: "Mezun",
      2: "Öğrenci",
      3: "Terk"
    };
    return map[id] || "";
  };

  useEffect(() => {
    fetchKategoriler();
  }, []);

  const fetchEgitimTurleri = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/EgitimTuru/getirhepsi`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await response.json();
      setEgitimTuruListesi(data.$values || []);
    } catch (error) {
      console.error("Eğitim türleri alınamadı:", error);
    }
  };

  useEffect(() => {
    if (egitimSeviyesi) {
      fetchOkullar(setOkulListesi);
      fetchBolumler(setBolumListesi);
      fetchEgitimTurleri(); // bu zaten yukarıda parametresiz tanımlı
    }
  }, [egitimSeviyesi]);

  const handleEgitimSilOnayla = async () => {
    if (currentStep === 1 && referanslar.some(r => r.referansId === silinecekEgitimID)) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/Referans/sil/${silinecekEgitimID}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setReferanslar(prev => prev.filter(r => r.referansId !== silinecekEgitimID));
        gosterUyari("Referans başarıyla silindi.", "✅ Silindi", "success");
      } catch (err) {
        console.error("❌ Referans silme hatası:", err);
        gosterUyari("Referans silinemedi.", "❌ Hata", "error");
      }
    } else {

      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/Egitim/sil/${silinecekEgitimID}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setEgitimler(prev => prev.filter(e => e.egitimID !== silinecekEgitimID));
        gosterUyari("Eğitim başarıyla silindi.", "✅ Silindi", "success");
      } catch (err) {
        console.error("❌ Eğitim silinemedi:", err);
        gosterUyari("Eğitim silinirken hata oluştu.", "❌ Hata", "error");
      }
    }

    setShowEgitimDeleteConfirm(false);
    setSilinecekEgitimID(null);
  };


  useEffect(() => {
    const fetchEgitimler = async () => {
      if (currentStep === 2 || showEgitimForm === false) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Egitim/benimegitimlerim`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          });
          setEgitimler(response.data.$values || []);

          fetchOkullar(setOkulListesi);
          fetchBolumler(setBolumListesi);
          fetchEgitimTurleri();
          fetchEgitimDurumlari(setEgitimDurumuListesi);

        } catch (err) {
          console.error("Eğitim verisi alınamadı:", err);
        }
      }
    };

    fetchEgitimler();
  }, [currentStep]);


  const [form, setForm] = useState({
    calismaTipiID: "",
    sektor: "",
    sirketAdi: "",
    bolum: "",
    deneyimPozisyon: "",
    ulke: "",
    baslangicTarihi: "",
    bitisTarihi: "",
    suanCalisiyorMu: false,
    aciklama: ""
  });

  const handleEditDeneyim = (item) => {
    setForm({
      deneyimID: item.deneyimID,
      sirketAdi: item.sirketAdi,
      deneyimPozisyon: item.deneyimPozisyon,
      aciklama: item.aciklama,
      baslangicTarihi: item.baslangicTarihi?.substring(0, 7),
      bitisTarihi: item.bitisTarihi ? item.bitisTarihi.substring(0, 7) : "",
      suanCalisiyorMu: item.suanCalisiyorMu,
      calismaTipiID: item.calismaTipiID.toString(),
      sektor: item.sektor || "",
      ulke: item.ulke || "",
      bolum: item.bolum || ""
    });

    setDuzenleMode(true);
    setShowDeneyimForm(true);
  };
  const handleEditEgitim = async (item) => {
    const kategori = kategoriListesi.find(k => k.egitimKategoriID === item.egitimKategoriID);
    const kategoriAdi = kategori?.egitimKategoriAdi || "";

    setEgitimSeviyesi(kategoriAdi);
    setShowEgitimForm(true);
    setDuzenleEgitimMode(true);
    setDuzenlenecekEgitim(item);

    await fetchOkullar(setOkulListesi);
    await fetchBolumler(setBolumListesi);
    await fetchEgitimTurleri();
    await fetchEgitimDurumlari(setEgitimDurumuListesi);
    const date = item.bitisTarihi ? new Date(item.bitisTarihi) : null;
    if (kategoriAdi === "Lise") {
      setEgitimForm({
        okul: item.egitimLise || "",
        bolum: item.egitimLiseBolum || "",
        egitimTuru: item.egitimTuruID?.toString() || "",
        egitimDurumu: egitimDurumuListesi.find(d => d.egitimDurumuID === item.egitimDurumuID)?.egitimDurumAdi || "",
        bitisAy: date.toLocaleString("tr-TR", { month: "long" }),
        bitisYil: date.getFullYear().toString()
      });
    } else {
      const date = new Date(item.bitisTarihi);
      setEgitimForm({
        okul: item.egitimLisansID?.toString() || "",
        bolum: item.egitimBolumID?.toString() || "",
        egitimTuru: item.egitimTuruID?.toString() || "",
        egitimDurumu: egitimDurumuListesi.find(d => d.egitimDurumuID === item.egitimDurumuID)?.egitimDurumAdi || "",
        bitisAy: date.toLocaleString("tr-TR", { month: "long" }),
        bitisYil: date.getFullYear().toString()
      });
    }
  };

  useEffect(() => {
    const fetchDeneyimler = async () => {
      if (currentStep === 1) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Deneyim/getirhepsi`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });

          const deneyimListesi = response.data.$values || [];

          const siraliDeneyimler = [...deneyimListesi].sort((a, b) => {
            const yilA = parseInt(a.bitisYil) || 0;
            const yilB = parseInt(b.bitisYil) || 0;
            return yilA - yilB; // eskiden yeniye
          });

          setDeneyimler(siraliDeneyimler);
          console.log("🧪 Yıla Göre Sıralı Deneyimler:", siraliDeneyimler);
        } catch (error) {
          console.error("Deneyim verisi alınamadı:", error);
        }
      }
    };

    fetchDeneyimler();
  }, [currentStep]);


  const hesaplaSureBilgisi = (baslangic, bitis, suanCalisiyorMu) => {
    if (!baslangic) return { metin: "-", ay: 0 };

    const start = new Date(baslangic);
    const end = suanCalisiyorMu ? new Date() : new Date(bitis);

    const years = end.getFullYear() - start.getFullYear();
    const months = end.getMonth() - start.getMonth();

    const totalMonths = years * 12 + months;

    const finalYears = Math.floor(totalMonths / 12);
    const finalMonths = totalMonths % 12;

    let metin = "";
    if (totalMonths <= 0) metin = "1 aydan az";
    else if (finalYears === 0) metin = `${finalMonths} ay`;
    else if (finalMonths === 0) metin = `${finalYears} yıl`;
    else metin = `${finalYears} yıl ${finalMonths} ay`;

    return {
      metin,
      ay: totalMonths < 0 ? 0 : totalMonths
    };
  };

  const [formData, setFormData] = useState({
    isim: "",
    soyisim: "",
    dogumTarihi: "",
    askerlik: "",
    ehliyet: "",
    cinsiyet: "",
    telefon: "",
    adres: "",
    maasBeklentisi: "",
    KisiIlId: "",
    KisiIlceId: "",
    KVKK: false,
    tcNo: "",
    yabanciUyruklu: false,
    yabanciKimlikNo: "",
    dogumYeri: "",
    seyahatDurumu: "",
    medeniDurumu: "",
    kanGrubu: "",
  });

  useEffect(() => {
    const fetchIller = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/KullaniciIl/getirhepsi`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        });
        console.log("İller verisi (map için):", response.data.$values);
        setIller(response.data.$values);
      } catch (error) {
        console.error("İl verisi alınamadı:", error);
      }
    };
    fetchIller();
  }, []);

  useEffect(() => {
    const fetchIlceler = async () => {
      if (!formData.KisiIlId) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciIlceler/ilcebyilid/${formData.KisiIlId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        );

        console.log("Seçilen İl ID:", formData.KisiIlId);
        console.log("İlçeler verisi (map için):", response.data.$values);

        const sortedIlceler = (response.data.$values || [])
          .filter(i => i.kisiIlceAdi)
          .sort((a, b) =>
            a.kisiIlceAdi.localeCompare(b.kisiIlceAdi, "tr", { sensitivity: "base" })
          );

        setIlceler(sortedIlceler);
      } catch (error) {
        console.error("İlçeler alınamadı:", error);
      }
    };

    fetchIlceler();
  }, [formData.KisiIlId]);

  const capitalizeText = (text) => {
    if (!text) return "";

    return text
      .toLocaleLowerCase("tr-TR")
      .replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toLocaleUpperCase("tr-TR"));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (currentStep === 0) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/GenelBilgiler`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          });
          const data = response.data;
          setKanGrubuOptions(data.kanGrubuOptions || []);
          setFormData((prev) => ({
            ...prev,
            isim: data.adi || "",
            soyisim: data.soyadi || "",
            askerlik: data.askerlikDurumu || "",
            ehliyet: data.ehliyet || "",
            cinsiyet: data.cinsiyet || "",
            telefon: data.telefon || "",
            dogumTarihi: data.dogumTarihi ? data.dogumTarihi.substring(0, 10) : "",
            adres: data.adres || "",
            maasBeklentisi: data.maasBeklenti || "",
            KisiIlId: data.kullaniciIl || "",
            KisiIlceId: data.kullaniciIlceler || "",
            tcNo: data.tc || "",
            dogumYeri: data.dogumYeri || "",
            vatandaslikDurum: data.vatandaslikDurum === true,
            phoneNumberConfirmed: data.phoneNumberConfirmed === true,
            kvkk: data.kvkk === true,
            seyahatDurumu: data.seyahatDurumu === true ? "true" : "false",
            medeniDurumu: data.medeniDurumu || "",
            kanGrubu: data.kanGrubu || "",
          }));
          if (data.kullaniciIl) {
            const ilceResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/KullaniciIlceler/ilcebyilid/${data.kullaniciIl}`);
            setIlceler(ilceResponse.data);
          }
        } catch (err) {
          console.error("Veri çekilirken hata oluştu:", err);
        }
      }
    };
    fetchData();
  }, [currentStep]);

  const formatMaas = (value) => {
    const onlyNumbers = value.replace(/\D/g, "");
    if (!onlyNumbers) return "";
    const formatted = parseInt(onlyNumbers).toLocaleString("tr-TR");
    return `${formatted} TL`;
  };

  const formatVisibleMaas = (value) => {
    const num = parseInt(value || "0");
    return isNaN(num) ? "" : num.toLocaleString("tr-TR");
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";

    const numbers = value.replace(/\D/g, "").slice(0, 10);
    const len = numbers.length;

    if (len === 0) return "";
    if (len <= 3) return `(${numbers}`;
    if (len <= 6) return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
    if (len <= 8) return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)} ${numbers.slice(6)}`;
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)} ${numbers.slice(6, 8)} ${numbers.slice(8)}`;
  };


  const handleNext = async () => {
    if (currentStep === 0) {
      const profilFotoVarMi = profilePhoto;

      if (!profilFotoVarMi) {
        setWarning("⚠️ Lütfen profil fotoğrafınızı yükleyin.");
        return;
      }

      const requiredFields = [
        { key: "isim", label: "İsim" },
        { key: "soyisim", label: "Soyisim" },
        { key: "dogumTarihi", label: "Doğum Tarihi" },
        { key: "askerlik", label: "Askerlik Durumu" },
        { key: "ehliyet", label: "Ehliyet" },
        { key: "cinsiyet", label: "Cinsiyet" },
        { key: "telefon", label: "Telefon" },
        { key: "adres", label: "Adres" },
        { key: "KisiIlId", label: "İl" },
        { key: "KisiIlceId", label: "İlçe" },
        { key: "maasBeklentisi", label: "Maaş Beklentisi" },
        { key: "medeniDurumu", label: "Medeni Durum" },
      ];

      for (let field of requiredFields) {
        const value = formData[field.key];
        if (value === "" || value === undefined || value === null) {
          setWarning(`⚠️ Lütfen '${field.label}' alanını doldurun.`);
          return;
        }
      }

      for (let field of requiredFields) {
        if (!formData[field.key]) {
          setWarning(`⚠️ Lütfen '${field.label}' alanını doldurun.`);
          return;
        }
      }

      if (formData.telefon.replace(/\D/g, "").length !== 10) {
        setWarning("⚠️ Lütfen geçerli bir telefon numarası girin (10 haneli).");
        return;
      }

      if (!formData.kvkk) {
        setWarning("⚠️ Devam etmek için KVKK kutusunu işaretlemelisiniz.");
        return;
      }


      setWarning("");

      // 🇹🇷 Sadece Türk vatandaşları için vatandaşlık doğrulaması
      if (!formData.yabanciUyruklu) {
        const dogumYili = formData.dogumTarihi?.split("-")[0];
        const kimlikPayload = {
          tc: formData.tcNo,
          ad: formData.isim?.trim().toUpperCase(),
          soyad: formData.soyisim?.trim().toUpperCase(),
          dogumYili: parseInt(dogumYili),
        };

        try {
          const kontrolRes = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/VatandaslikKontrol`, kimlikPayload);
          if (kontrolRes.status !== 200) {
            setWarning("❌ Vatandaşlık doğrulaması başarısız. Bilgileri kontrol edin.");
            return;
          }
          setKimlikDogrulandi(true);
        } catch (err) {
          console.error("Vatandaşlık kontrolü hatası:", err);
          setWarning("❌ T.C. Kimlik doğrulaması başarısız. Lütfen bilgilerinizi kontrol edin.");
          return;
        }
      }

      // ✅ Genel Bilgileri Kaydet
      try {
        const payload = {
          Id: "string",
          adi: formData.isim,
          soyadi: formData.soyisim,
          askerlikDurumu: formData.askerlik,
          ehliyet: formData.ehliyet,
          cinsiyet: formData.cinsiyet,
          telefon: formData.telefon,
          dogumTarihi: formData.dogumTarihi,
          adres: formData.adres,
          maasBeklenti: formData.maasBeklentisi.toString(),
          kullaniciIl: parseInt(formData.KisiIlId),
          kullaniciIlceler: parseInt(formData.KisiIlceId),
          kvkk: formData.kvkk === true,
          tc: formData.tcNo,
          dogumYeri: formData.dogumYeri,
          yabanciKimlikNo: formData.yabanciKimlikNo,
          medeniDurumu: formData.medeniDurumu,
          seyahatDurumu: formData.seyahatDurumu === "true",
          kanGrubu: formData.kanGrubu,
        };

        console.log("🔍 API'ye gönderilen payload:", payload);

        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/GenelBilgiler`, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        });

      } catch (error) {
        console.error("❌ API Hatası:", error.response?.data || error.message);
        gosterUyari("Hata: " + JSON.stringify(error.response?.data), "❌ Hata", "error");
        setWarning("Veriler kaydedilirken hata oluştu.");
        return;
      }
    }

    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  const toTurkishUpperCase = (str) => {
    return str
      .replace(/i/g, "İ")
      .replace(/ı/g, "I")
      .replace(/ş/g, "Ş")
      .replace(/ğ/g, "Ğ")
      .replace(/ü/g, "Ü")
      .replace(/ö/g, "Ö")
      .replace(/ç/g, "Ç")
      .toUpperCase();
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    let newValue = value;

    if (name === "isim" || name === "soyisim") {
      newValue = toTurkishUpperCase(value);
    } else if (name === "adres") {
      newValue = capitalizeText(value);
    }

    const updatedFormData = {
      ...formData,
      [name]: newValue,
    };

    setFormData(updatedFormData);

    if (name === "kanGrubu" && newValue) {
      try {
        const payload = {
          Id: "string",
          adi: updatedFormData.isim,
          soyadi: updatedFormData.soyisim,
          askerlikDurumu: updatedFormData.askerlik,
          ehliyet: updatedFormData.ehliyet,
          cinsiyet: updatedFormData.cinsiyet,
          telefon: updatedFormData.telefon,
          dogumTarihi: updatedFormData.dogumTarihi,
          adres: updatedFormData.adres,
          maasBeklenti: updatedFormData.maasBeklentisi?.toString(),
          kullaniciIl: parseInt(updatedFormData.KisiIlId),
          kullaniciIlceler: parseInt(updatedFormData.KisiIlceId),
          kvkk: updatedFormData.kvkk === true,
          tc: updatedFormData.tcNo,
          dogumYeri: updatedFormData.dogumYeri,
          yabanciKimlikNo: updatedFormData.yabanciKimlikNo,
          medeniDurumu: updatedFormData.medeniDurumu,
          seyahatDurumu: updatedFormData.seyahatDurumu === "true",
          kanGrubu: newValue,
        };

        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/api/Auth/GenelBilgiler`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        setHighlightKanGrubu(false);
        console.log("Kan grubu otomatik kaydedildi:", newValue);
      } catch (err) {
        console.error("Kan grubu otomatik kaydedilemedi:", err);
        setWarning("Kan grubu kaydedilemedi. Lütfen Devam Et butonuyla tekrar deneyin.");
      }
    }
  };

  const handleExperienceChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    // 🔠 Şirket adı ve pozisyon için düzenleme
    if (name === "sirketAdi" || name === "deneyimPozisyon") {
      newValue = capitalizeText(value);
    }

    setForm((prev) => {
      const updatedForm = {
        ...prev,
        [name]: newValue,
      };

      // 🔄 Eğer şu an çalışıyor checkbox'ı işaretlendiyse bitiş tarihini sıfırla
      if (name === "suanCalisiyorMu" && checked) {
        updatedForm.bitisTarihi = "";
      }

      return updatedForm;
    });
  };


  const handleCancel = () => {
    setShowDeneyimForm(false);
    setForm({
      calismaTipiID: "",
      sektor: "",
      sirketAdi: "",
      bolum: "",
      deneyimPozisyon: "",
      ulke: "",
      baslangicTarihi: "",
      bitisTarihi: "",
      suanCalisiyorMu: false,
      aciklama: "",
    });
  };

  const handleDeleteOnayla = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/Deneyim/sil/${silID}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      setDeneyimler(prev => prev.filter(d => d.deneyimID !== silID));
      setShowDeleteConfirm(false);
      gosterUyari("Deneyim başarıyla silindi.", "✅ Silindi", "success");
    } catch (err) {
      console.error("❌ Deneyim silinemedi:", err);
      gosterUyari("Silme işlemi sırasında hata oluştu.", "❌ Hata", "error");
    }
  };



  const handleAddExperience = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Token bulunamadı. Lütfen giriş yapın.");
      return;
    }
    const sure = hesaplaSureBilgisi(form.baslangicTarihi, form.bitisTarihi, form.suanCalisiyorMu);
    const payload = {
      deneyimID: duzenleMode && form.deneyimID ? form.deneyimID : 0,
      sirketAdi: form.sirketAdi,
      deneyimPozisyon: form.deneyimPozisyon,
      aciklama: form.aciklama,
      status: true,
      baslangicTarihi: `${form.baslangicTarihi}-01T00:00:00Z`,
      bitisTarihi: form.suanCalisiyorMu ? null : `${form.bitisTarihi}-01T00:00:00Z`,
      suanCalisiyorMu: form.suanCalisiyorMu,
      toplamCalismaSuresi: sure.ay,
      cvID: 0,
      calismaTipiID: parseInt(form.calismaTipiID),
    };

    console.log("📤 Gönderilen Deneyim Payload:", payload);
    try {
      let response;

      if (duzenleMode) {
        // ✏️ GÜNCELLEME
        response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/Deneyim/guncelle`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        gosterUyari("Deneyim başarıyla güncellendi!", "✅ Başarılı", "success");
      } else {
        // ➕ EKLEME
        response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Deneyim/ekle`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        gosterUyari("Deneyim başarıyla eklendi!", "✅ Başarılı", "success");
      }

      // Listeyi güncelle
      const updated = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Deneyim/getirhepsi`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDeneyimler(updated.data.$values);

      // Form ve modları resetle
      setShowDeneyimForm(false);
      setDuzenleMode(false);
      setDuzenlenecekDeneyim(null);
      setForm({
        calismaTipiID: "",
        sektor: "",
        sirketAdi: "",
        bolum: "",
        deneyimPozisyon: "",
        ulke: "",
        baslangicTarihi: "",
        bitisTarihi: "",
        suanCalisiyorMu: false,
        aciklama: ""
      });

    } catch (error) {
      console.error("❌ İşlem sırasında hata oluştu:", error);
      gosterUyari("Deneyim eklenirken veya güncellenirken hata oluştu.", "❌ Hata", "error");
    }
  };

  const kisiselDereceler = ["Arkadaş", "Akraba", "Diğer"];
  const profesyonelDereceler = ["Üst Yönetici", "Çalışma Arkadaşı", "Diğer"];



  return (

    <div className="cv-container">
      <div className="step-indicator">
        {steps.map((step, index) => (
          <div key={index} className={`step ${index === currentStep ? "active" : index < currentStep ? "completed" : ""}`}>
            <span>{index + 1}</span>
            {step}
          </div>
        ))}
      </div>

      <div className="form-section">
        {currentStep === 0 && (
          <div className="genel-wrapper">
            <div className="genel-bilgiler-form-grid">

              {/* T.C. Kimlik No + Yabancı */}
              <div className="genel-grid-item tcno-wrapper">
                <label>T.C. Kimlik No:</label>
                <div className="tcno-flex">
                  <input
                    type="text"
                    name="tcNo"
                    maxLength="11"
                    value={formData.tcNo}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setFormData((prev) => ({ ...prev, tcNo: value }));
                    }}
                    disabled={formData.yabanciUyruklu || formData.vatandaslikDurum}
                  />


                  <label className="yabanci-checkbox">
                    <input
                      type="checkbox"
                      checked={formData.yabanciUyruklu}
                      onChange={(e) => {
                        const yabanci = e.target.checked;
                        setFormData((prev) => ({
                          ...prev,
                          yabanciUyruklu: yabanci,
                          tcNo: yabanci ? "11111111111" : "",
                          yabanciKimlikNo: "",
                        }));
                      }}
                    />
                    <span>Yabancı Uyrukluyum</span>
                  </label>
                </div>
              </div>

              {formData.yabanciUyruklu && (
                <div className="genel-grid-item">
                  <label>Yabancı Kimlik No:</label>
                  <input
                    type="text"
                    name="yabanciKimlikNo"
                    value={formData.yabanciKimlikNo}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, yabanciKimlikNo: e.target.value }))
                    }
                  />
                </div>
              )}

              <div className="genel-grid-item">
                <label>İsim:</label>
                <input type="text" name="isim" value={formData.isim} onChange={handleChange} disabled={formData.vatandaslikDurum}
                />
              </div>

              <div className="genel-grid-item">
                <label>Soyisim:</label>
                <input type="text" name="soyisim" value={formData.soyisim} onChange={handleChange} disabled={formData.vatandaslikDurum} />
              </div>

              <div className="genel-grid-item">
                <label>Telefon:</label>
                <input
                  type="text"
                  name="telefon"
                  value={formatPhoneNumber(formData.telefon)}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/\D/g, "");
                    const limited = raw.slice(0, 10);
                    setFormData((prev) => ({ ...prev, telefon: limited }));
                  }}
                  placeholder="(5xx) xxx xx xx"
                  disabled={formData.phoneNumberConfirmed}
                />

              </div>


              <div className="genel-grid-item">
                <label>Doğum Tarihi:</label>
                <input type="date" name="dogumTarihi" value={formData.dogumTarihi} onChange={handleChange} disabled={formData.vatandaslikDurum} />
              </div>

              <div className="genel-grid-item">
                <label>Doğum Yeri:</label>
                <select
                  name="dogumYeri"
                  value={formData.dogumYeri}
                  onChange={handleChange}
                >
                  <option value="">Seçiniz</option>
                  {iller.map((il) => (
                    <option key={il.kullaniciIlID} value={il.kullaniciIlAdi}>
                      {il.kullaniciIlAdi}
                    </option>
                  ))}
                </select>
              </div>


              <div className="genel-grid-item">
                <label>Maaş Beklentisi:</label>
                <div className="maas-input-wrapper">
                  <input
                    type="text"
                    name="maasBeklentisi"
                    className="maas-input"
                    value={formatVisibleMaas(formData.maasBeklentisi)}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        maasBeklentisi: e.target.value.replace(/\D/g, ""),
                      }))
                    }
                  />
                  <span className="maas-tl">TL</span>
                </div>
              </div>

              <div className="genel-grid-item">
                <label>Askerlik Durumu:</label>
                <select name="askerlik" value={formData.askerlik} onChange={handleChange}>
                  <option value="">Seçiniz</option>
                  <option value="tamamlandi">Tamamlandı</option>
                  <option value="tecilli">Tecilli</option>
                  <option value="muaf">Muaf</option>
                </select>
              </div>

              <div className="genel-grid-item genel-ehliyet-kan-row">
                <div className="genel-mini-select">
                  <label>Ehliyet:</label>
                  <select name="ehliyet" value={formData.ehliyet} onChange={handleChange}>
                    <option value="">Seçiniz</option>
                    <option value="YOK">Yok</option>
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                    <option value="D">D</option>
                    <option value="E">E</option>
                    <option value="F">F</option>
                    <option value="G">G</option>
                  </select>
                </div>

                <div
                  id="kanGrubuAlan"
                  className={`genel-mini-select ${highlightKanGrubu ? "kan-error" : ""}`}
                >
                  <label>Kan Grubu:</label>

                  <select
                    name="kanGrubu"
                    value={formData.kanGrubu}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>

                    {kanGrubuOptions.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="genel-grid-item">
                <label>Cinsiyet:</label>
                <select name="cinsiyet" value={formData.cinsiyet} onChange={handleChange}>
                  <option value="">Seçiniz</option>
                  <option value="erkek">Erkek</option>
                  <option value="kadın">Kadın</option>
                  <option value="diger">Diğer</option>
                </select>
              </div>

              <div className="genel-grid-item">
                <label>Medeni Durum:</label>
                <select
                  name="medeniDurumu"
                  value={formData.medeniDurumu}
                  onChange={(e) => setFormData((prev) => ({ ...prev, medeniDurumu: e.target.value }))}
                >
                  <option value="">Seçiniz</option>
                  <option value="Bekar">Bekar</option>
                  <option value="Evli">Evli</option>
                </select>
              </div>

              <div className="genel-grid-item">
                <label>Seyahat Durumu:</label>
                <select
                  name="seyahatDurumu"
                  value={formData.seyahatDurumu}
                  onChange={(e) => setFormData(prev => ({
                    ...prev,
                    seyahatDurumu: e.target.value,
                  }))}
                >
                  <option value="">Seçiniz</option>
                  <option value="true">Seyahat Engelim Yok</option>
                  <option value="false">Seyahat Engelim Var</option>
                </select>
              </div>

              <div className="genel-grid-item">
                <label>İkametgah İl :</label>
                <select name="KisiIlId" value={formData.KisiIlId} onChange={handleChange}>
                  <option value="">Seçiniz</option>
                  {iller.map((il) => (
                    <option key={il.kullaniciIlID} value={il.kullaniciIlID}>
                      {il.kullaniciIlAdi}
                    </option>
                  ))}
                </select>
              </div>

              <div className="genel-grid-item">
                <label>İkametgah İlçe :</label>
                <select
                  name="KisiIlceId"
                  value={formData.KisiIlceId}
                  onChange={handleChange}
                >
                  <option value="">İlçe Seçiniz</option>
                  {ilceler.map((ilce) => (
                    <option key={ilce.kisiIlceId} value={ilce.kisiIlceId}>
                      {ilce.kisiIlceAdi}
                    </option>
                  ))}
                </select>
              </div>

              <div className="genel-grid-item genel-adres-fotolu">
                <label className="genel-full-label">Açık Adres:</label>
                <div className="genel-adres-foto-container">
                  <textarea
                    name="adres"
                    value={formData.adres}
                    onChange={handleChange}
                    rows="4"
                    className="genel-adres-textarea"
                    placeholder="Açık adresinizi giriniz"
                  />

                  <div id="profilePhotoAlan" className="genel-avatar-wrapper">
                    {profilePhoto ? (
                      <>
                        {/* 📷 Fotoğraf gösterme ve büyütme */}
                        <img
                          src={profilePhoto}
                          alt="Profil"
                          className="genel-avatar-img"
                          onClick={() => setShowFullPhoto(true)} // ✅ sadece büyütme için
                        />

                        {/* 📤 Değiştir butonu */}
                        <label
                          htmlFor={fotoKaydediliyor ? undefined : "photoUpload"}
                          className={`genel-avatar-text ${fotoKaydediliyor ? "disabled" : ""}`}
                        >
                          {fotoKaydediliyor ? "Kaydediliyor..." : "Fotoğrafı Değiştir"}
                        </label>
                      </>
                    ) : (
                      <>
                        <label htmlFor="photoUpload" className="genel-avatar-label">
                          <div className="genel-avatar-empty"></div>
                          <span className={`genel-avatar-text ${fotoKaydediliyor ? "disabled" : ""}`}>
                            {fotoKaydediliyor ? "Kaydediliyor..." : "Fotoğraf Yükle"}
                          </span>
                        </label>
                      </>
                    )}

                    <input
                      id="photoUpload"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handlePhotoUpload}
                      disabled={fotoKaydediliyor}
                    />
                  </div>
                </div>
              </div>


              <div className="kvkk-wrapper">
                <label className="kvkk-label">
                  <input
                    type="checkbox"
                    name="kvkk"
                    checked={formData.kvkk}
                    disabled={formData.kvkk} // ✅ daha önce işaretlendiyse pasif yap
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, kvkk: e.target.checked }))
                    }
                  />
                  <span className="kvkk-link" onClick={() => setShowKvkkModal(true)}>
                    KVKK Metnini Okudum
                  </span>
                </label>
              </div>

              {warning && <div className="warning-popup-bottom">{warning}</div>}
            </div>
          </div>
        )}



        {currentStep === 1 && (
          <div className="deneyim-container">
            <h2>İş deneyimlerinden söz eder misin?</h2>
            <p>İş deneyimlerini paylaşarak, kariyerinle ilgili fikir edinmemizi sağlayabilirsin.</p>

            {showDeneyimForm && (
              <div className="modal-overlay-deneyim" onClick={() => setShowDeneyimForm(false)}>
                <div className="modal-popup-deneyim" onClick={(e) => e.stopPropagation()}>
                  <h3>{duzenleMode ? "Deneyimi Güncelle" : "Deneyim Ekle"}</h3>

                  <div className="deneyim-form-row">
                    <label>Şirket Adı:</label>
                    <input type="text" name="sirketAdi" value={form.sirketAdi} onChange={handleExperienceChange} />
                  </div>

                  <div className="deneyim-form-row">
                    <label>Pozisyon:</label>
                    <input type="text" name="deneyimPozisyon" value={form.deneyimPozisyon} onChange={handleExperienceChange} />
                  </div>

                  <div className="deneyim-form-row">
                    <label>Çalışma Tipi:</label>
                    <select name="calismaTipiID" value={form.calismaTipiID} onChange={handleExperienceChange}>
                      <option value="">Seçiniz</option>
                      <option value="1">Tam Zamanlı</option>
                      <option value="2">Yarı Zamanlı</option>
                      <option value="3">Uzaktan</option>
                      <option value="4">Stajyer</option>

                    </select>
                  </div>

                  <div className="deneyim-form-row">
                    <label>Başlangıç Tarihi:</label>
                    <input type="month" name="baslangicTarihi" value={form.baslangicTarihi} onChange={handleExperienceChange} />
                  </div>

                  {!form.suanCalisiyorMu && (
                    <div className="deneyim-form-row">
                      <label>Bitiş Tarihi:</label>
                      <input type="month" name="bitisTarihi" value={form.bitisTarihi} onChange={handleExperienceChange} /></div>
                  )}

                  <div className="deneyim-checkbox-wrapper">
                    <input
                      type="checkbox"
                      name="suanCalisiyorMu"
                      checked={form.suanCalisiyorMu}
                      onChange={handleExperienceChange}
                    />
                    <label htmlFor="suanCalisiyorMu">Hâlâ çalışıyorum</label>
                  </div>

                  <div className="deneyim-form-row">
                    <label>Açıklama:</label>
                    <textarea
                      name="aciklama"
                      rows="3"
                      value={form.aciklama}
                      onChange={(e) =>
                        setForm((prev) => ({ ...prev, aciklama: capitalizeText(e.target.value) }))
                      }
                    />
                  </div>

                  <div className="form-buttons">
                    <button className="cancel-btn" onClick={handleCancel}>Vazgeç</button>
                    <button className="submit-btn" onClick={handleAddExperience}>
                      {duzenleMode ? "Güncelle" : "Ekle"}
                    </button>
                  </div>

                </div>
              </div>
            )}

            <div className="deneyim-add-area">
              <div className="deneyim-add-header">
                <label></label>
                <button
                  onClick={() => {
                    setShowDeneyimForm(true);
                    setDuzenleMode(false);
                    setForm({
                      calismaTipiID: "",
                      sektor: "",
                      sirketAdi: "",
                      bolum: "",
                      deneyimPozisyon: "",
                      ulke: "",
                      baslangicTarihi: "",
                      bitisTarihi: "",
                      suanCalisiyorMu: false,
                      aciklama: "",
                    });
                  }}
                  className="deneyim-add-button"
                  disabled={noExperience}
                  style={{ opacity: noExperience ? 0.5 : 1, cursor: noExperience ? "not-allowed" : "pointer" }}
                >
                  ➕ Deneyim Ekle
                </button>
              </div>
              <label className={`checkbox-no-experience ${deneyimler.length > 0 ? "disabled" : ""}`}>
                <input
                  type="checkbox"
                  checked={noExperience}
                  onChange={(e) => {
                    setNoExperience(e.target.checked);
                    if (e.target.checked) setShowDeneyimForm(false);
                  }}
                  disabled={deneyimler.length > 0}
                />
                <strong>Henüz iş deneyimim yok</strong>
              </label>

            </div>
            {deneyimler.length > 0 && (
              <div className="deneyim-liste">
                <h3>📌 Eklenen Deneyimler:</h3>
                {deneyimler.map((item, index) => {
                  const { metin: sureMetni } = hesaplaSureBilgisi(item.baslangicTarihi, item.bitisTarihi, item.suanCalisiyorMu);
                  return (
                    <div key={index} className="deneyim-karti kart-kapsayici" style={{ position: "relative" }}>
                      {/* 🔴 Sağ üst: Sil butonu */}
                      <button
                        className="sil-btn-ikon"
                        onClick={() => {
                          setSilID(item.deneyimID);
                          setShowDeleteConfirm(true);
                        }}
                      >
                        <img src="/images/delete.png" alt="sil" />
                      </button>

                      {/* 📋 Deneyim Bilgileri */}
                      <div className="deneyim-icerik kart-icerik">
                        <div><strong>Şirket:</strong> {item.sirketAdi}</div>
                        <div><strong>Pozisyon:</strong> {item.deneyimPozisyon}</div>
                        <div>
                          <strong>Tarih:</strong> {item.baslangicTarihi?.slice(0, 7)} - {item.suanCalisiyorMu ? "Devam Ediyor" : item.bitisTarihi?.slice(0, 7)}
                          <span className="deneyim-sure"> ({sureMetni})</span>
                        </div>
                        <div className="deneyim-aciklama">
                          <div className="aciklama-baslik"><strong>Açıklama:</strong></div>
                          <div className="aciklama-metin">{item.aciklama || "-"}</div>
                        </div>
                      </div>

                      {/* ✏️ Sağ alt: Düzenle butonu */}
                      <div className="kart-duzenle-btn">
                        <button className="kalem-btn" onClick={() => handleEditDeneyim(item)}>✏️</button>
                      </div>
                    </div>

                  );
                })}


                <div className="referans-header">
                  {/* 🧾 Referans Listesi */}
                  <h2>Referansların var mı?</h2>
                  <p>Profesyonel veya kişisel referanslarını paylaşabilirsin.</p>
                  <h3 className="referans-liste-baslik">Eklenen Referanslar</h3>

                  <div className="referans-add-area">
                    <div className="referans-add-header">
                      <label></label>
                      <button
                        onClick={() => {
                          setShowReferansPopup(true);
                          setReferansForm({
                            referansAdi: "",
                            referansNumara: "",
                            referansAciklama: "",
                            referansFirmaKurum: "",
                            referansPozisyon: "",
                            referansDerece: "",
                            referansMail: "",
                            profosyonelRefmi: false,
                            status: true,
                            cvid: 0,
                            referansId: 0,
                          });
                        }}
                        className="referans-add-button"
                        disabled={noReference}
                        style={{
                          opacity: noReference ? 0.5 : 1,
                          cursor: noReference ? "not-allowed" : "pointer"
                        }}
                      >
                        ➕ Referans Ekle
                      </button>
                    </div>

                    <label className={`referans-no-experience ${referanslar.length > 0 ? "disabled" : ""}`}>
                      <input
                        type="checkbox"
                        checked={noReference}
                        onChange={(e) => {
                          setNoReference(e.target.checked);
                          if (e.target.checked) setShowReferansPopup(false);
                        }}
                        disabled={referanslar.length > 0}
                      />
                      <strong>Referansım yok</strong>
                    </label>
                  </div>


                  {referanslar.map((ref, index) => (
                    <div key={index} className="referans-karti kart-kapsayici" style={{ position: "relative" }}>
                      {/* Sağ üst: Sil butonu */}
                      <button
                        className="sil-btn-ikon"
                        onClick={() => {
                          setSilinecekReferansID(ref.referansId);
                          setShowReferansDeleteConfirm(true);
                        }}
                      >
                        <img src="/images/delete.png" alt="sil" />
                      </button>


                      {/* Kart içeriği */}
                      <div className="kart-icerik">
                        <div className="referans-info-line"><strong>Adı:</strong> {ref.referansAdi}</div>
                        <div className="referans-info-line"><strong>Firma:</strong> {ref.referansFirmaKurum}</div>
                        <div className="referans-info-line"><strong>Pozisyon:</strong> {ref.referansPozisyon}</div>
                        <div className="referans-info-line"><strong>Yakınlık:</strong> {ref.referansDerece}</div>
                        <div className="referans-info-line"><strong>Telefon:</strong> {ref.referansNumara}</div>
                        <div className="referans-info-line"><strong>Email:</strong> {ref.referansMail}</div>
                        <div className="referans-info-line"><strong>Açıklama:</strong> {ref.referansAciklama}</div>
                      </div>

                      {/* Sağ alt: Düzenle butonu */}
                      <div className="kart-duzenle-btn">
                        <button
                          className="kalem-btn"
                          onClick={() => {
                            setReferansForm(ref);
                            setShowReferansPopup(true);
                          }}
                        >
                          ✏️
                        </button>
                      </div>
                    </div>
                  ))}

                </div>
              </div>
            )}
          </div>
        )}


        {currentStep === 2 && (
          <div className="egitim-container">
            <h2>Eğitim bilgilerini bizimle paylaşır mısın?</h2>
            <p>Eğitim bilgilerini paylaşarak seni daha iyi tanıyabiliriz.</p>
            {showEgitimForm && (
              <div className="modal-overlay-egitim" onClick={() => {
                setShowEgitimForm(false);
                setEgitimSeviyesi(null);
              }}>
                <div className="modal-popup-egitim" onClick={(e) => e.stopPropagation()}>
                  {!egitimSeviyesi && (
                    <button className="close-button" onClick={() => {
                      setShowEgitimForm(false);
                      setEgitimSeviyesi(null);
                    }}>
                      &times;
                    </button>
                  )}

                  {!egitimSeviyesi && !duzenleEgitimMode ? (
                    <>
                      <h3 className="popup-title">Eğitim Ekle</h3>
                      <div className="egitim-seviyesi-buttons">
                        {Array.isArray(kategoriListesi) && kategoriListesi.map((kategori) => {
                          const sev = kategori.egitimKategoriAdi;
                          const kategoriID = kategori.egitimKategoriID;
                          const isDisabled = kategoriID !== 1 && !liseEklendi; // Lise eklenmemişse diğerlerini kapat
                          return (
                            <button
                              key={kategoriID}
                              className={`egitim-seviyesi-btn ${egitimSeviyesi === sev ? "active" : ""}`}
                              onClick={() => {
                                if (isDisabled) {
                                  setUyariGoster(true);
                                } else {
                                  setEgitimSeviyesi(sev);
                                  setUyariGoster(false);
                                }
                              }}
                            >
                              {sev}
                            </button>
                          );
                        })}
                      </div>

                      {/* 🔴 Sadece uyarı aktifse göster */}
                      {uyariGoster && (
                        <p style={{ color: "red", fontWeight: "bold", marginTop: "10px" }}>
                          Öncelikle <u>Lise</u> bilgisi eklemelisiniz.
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      <h3 className="popup-title">{egitimSeviyesi} Bilgileri</h3>

                      {egitimSeviyesi === "Lise" ? (
                        <>
                          {/* Lise için eski form alanları buraya kalacak */}
                          <div className="form-row">
                            <label>Okul:</label>
                            <input
                              type="text"
                              name="okul"
                              value={egitimForm.okul || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, okul: capitalizeText(e.target.value) })}
                            />

                          </div>

                          <div className="form-row">
                            <label>Bölüm:</label>
                            <input
                              type="text"
                              name="bolum"
                              value={egitimForm.bolum || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, bolum: capitalizeText(e.target.value) })}
                            />

                          </div>
                          <div className="form-row">
                            <label>Türü:</label>
                            <select
                              value={egitimForm.egitimTuru || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, egitimTuru: e.target.value })}
                            >
                              <option value="">Seçiniz</option>
                              <option value="1">Örgün</option>
                              <option value="2">Açık Öğretim</option>
                              <option value="3">İkinci Öğretim</option>
                            </select>
                          </div>

                          <div className="form-row">
                            <label>Durumu:</label>
                            <select
                              value={egitimForm.egitimDurumu || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, egitimDurumu: e.target.value })}
                            >
                              <option value="">Seçiniz</option>
                              {egitimDurumuListesi.map((durum) => (
                                <option key={durum.egitimDurumuID} value={durum.egitimDurumAdi}>
                                  {durum.egitimDurumAdi}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-row">
                            <label>Bitiş Tarihi:</label>
                            <div className="date-select">
                              <select
                                value={egitimForm.bitisAy || ""}
                                onChange={(e) => setEgitimForm({ ...egitimForm, bitisAy: e.target.value })}
                              >
                                <option value="">Ay</option>
                                {["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"].map((ay) => (
                                  <option key={ay} value={ay}>{ay}</option>
                                ))}
                              </select>
                              <select
                                value={egitimForm.bitisYil || ""}
                                onChange={(e) => setEgitimForm({ ...egitimForm, bitisYil: e.target.value })}
                              >
                                <option value="">Yıl</option>
                                {Array.from({ length: 121 }, (_, i) => 1980 + i).map((yil) => (
                                  <option key={yil} value={yil}>{yil}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {/* Diğer eğitim seviyeleri için yeni form alanları */}
                          <div className="form-row">
                            <label>Okul:</label>
                            <select
                              value={egitimForm.okul || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, okul: e.target.value })}
                            >
                              <option value="">Seçiniz</option>
                              {okulListesi.map((okul) => (
                                <option key={okul.egitimLisansID} value={okul.egitimLisansID}>
                                  {okul.egitimLisansAdi}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-row">
                            <label>Bölüm:</label>
                            <select
                              value={egitimForm.bolum || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, bolum: e.target.value })}
                            >
                              <option value="">Seçiniz</option>
                              {bolumListesi.map((bolum) => (
                                <option key={bolum.egitimBolumID} value={bolum.egitimBolumID}>
                                  {bolum.egitimBolumAdi}
                                </option>
                              ))}
                            </select>
                          </div>


                          <div className="form-row">
                            <label>Türü:</label>
                            <select
                              value={egitimForm.egitimTuru || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, egitimTuru: e.target.value })}
                            >
                              <option value="">Seçiniz</option>
                              <option value="1">Örgün</option>
                              <option value="2">Açık Öğretim</option>
                              <option value="3">İkinci Öğretim</option>
                            </select>
                          </div>

                          <div className="form-row">
                            <label>Durumu:</label>
                            <select
                              value={egitimForm.egitimDurumu || ""}
                              onChange={(e) => setEgitimForm({ ...egitimForm, egitimDurumu: e.target.value })}
                            >
                              <option value="">Seçiniz</option>
                              {egitimDurumuListesi.map((durum) => (
                                <option key={durum.egitimDurumuID} value={durum.egitimDurumAdi}>
                                  {durum.egitimDurumAdi}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-row">
                            <label>Bitiş Tarihi:</label>
                            <div className="date-select">
                              <select
                                value={egitimForm.bitisAy || ""}
                                onChange={(e) => setEgitimForm({ ...egitimForm, bitisAy: e.target.value })}
                              >
                                <option value="">Ay</option>
                                {["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"].map((ay) => (
                                  <option key={ay} value={ay}>{ay}</option>
                                ))}
                              </select>
                              <select
                                value={egitimForm.bitisYil || ""}
                                onChange={(e) => setEgitimForm({ ...egitimForm, bitisYil: e.target.value })}
                              >
                                <option value="">Yıl</option>
                                {Array.from({ length: 121 }, (_, i) => 1980 + i).map((yil) => (
                                  <option key={yil} value={yil}>{yil}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="form-buttons">
                        <button
                          className="cancel-btn"
                          onClick={() => {
                            if (duzenleEgitimMode) {
                              setShowEgitimForm(false);
                              setDuzenleEgitimMode(false);
                              setDuzenlenecekEgitim(null);
                              setEgitimSeviyesi(null);
                              setEgitimForm({});
                            } else {
                              setEgitimSeviyesi(null);
                              setEgitimForm({});
                            }
                          }}
                        >
                          {duzenleEgitimMode ? "Vazgeç" : "Geri"}
                        </button>

                        <button className="submit-btn" onClick={egitimEkle}>
                          {duzenleEgitimMode ? "Güncelle" : "Ekle"}
                        </button>
                      </div>

                    </>
                  )}
                </div>
              </div>
            )}

            <div className="egitim-add-area" style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={() => {
                  setShowEgitimForm(true);
                  setDuzenleEgitimMode(false);
                  setDuzenlenecekEgitim(null);
                  setEgitimForm({});
                  fetchKategoriler();
                }}
                className="egitim-add-button"
              >
                ➕ Eğitim Ekle
              </button>
            </div>


            {true && (
              <div className="egitim-liste">
                <h3>🎓 Eklenen Eğitimler:</h3>
                <div className="egitim-grid">
                  {egitimler.map((item, index) => {
                    const bitis = item.bitisTarihi?.split("T")[0]?.slice(0, 7) || "-";
                    const isLise = !!item.egitimLise;
                    const date = item.bitisTarihi ? new Date(item.bitisTarihi) : null;

                    return (
                      <div key={index} className="egitim-karti kart-kapsayici" style={{ position: "relative" }}>
                        {/* Sağ üst: Sil */}
                        <button
                          className="sil-btn-ikon"
                          onClick={() => {
                            setSilinecekEgitimID(item.egitimID);
                            setShowEgitimDeleteConfirm(true);
                          }}
                        >
                          <img src="/images/delete.png" alt="sil" />
                        </button>

                        {/* Sağ alt: Düzenle */}
                        <div className="kart-duzenle-btn">
                          <button
                            className="kalem-btn"
                            onClick={() => handleEditEgitim(item)}
                            title="Düzenle"
                          >
                            ✏️
                          </button>
                        </div>

                        {/* 📘 Eğitim Bilgileri */}
                        <div className="egitim-icerik1 kart-icerik">
                          <strong>Seviye:</strong>{" "}
                          {isLise
                            ? "Lise"
                            : kategoriListesi.find((k) => k.egitimKategoriID === item.egitimKategoriID)?.egitimKategoriAdi || "-"}
                          <br />
                          <strong>Okul:</strong>{" "}
                          {isLise ? item.egitimLise : getOkulAdiByID(item.egitimLisansID)}
                          <br />
                          <strong>Bölüm:</strong>{" "}
                          {isLise ? item.egitimLiseBolum : getBolumAdiByID(item.egitimBolumID)}
                          <br />
                          <strong>Tür:</strong> {getEgitimTuruAdiByID(item.egitimTuruID)}
                          <br />
                          <strong>Durum:</strong> {getEgitimDurumAdiByID(item.egitimDurumuID)}
                          <br />
                          <strong>Bitiş:</strong>{" "}
                          {date ? date.toLocaleDateString("tr-TR", { month: "long", year: "numeric" }) : "-"}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}

        {currentStep === 3 && (
          <div className="yetkinlikler-container">
            <h2>Yabancı Dil ve Sertifikalarını paylaşır mısın?</h2>
            <p>Yabancı dil bilgilerin seni öne çıkarır. Hadi ekleyelim!</p>

            <div className="ekle-btn-container">
              <button
                className="dil-ekle-btn"
                onClick={() => {
                  setShowDilPopup(true);
                  setDuzenlenecekDil(null);
                  setDilForm({ dilID: "", okuma: "", yazma: "", konusma: "", dinleme: "" });
                }}
              >
                ➕ Dil Ekle
              </button>
            </div>
            {/* ➕ Dil Popup */}
            {showDilPopup && (
              <div className="modal-overlay" onClick={() => setShowDilPopup(false)}>
                <div className="dil-modal-popup" onClick={(e) => e.stopPropagation()}>

                  <h3>Yeni Dil Ekle</h3>

                  <label>Dil:</label>
                  <select
                    value={dilForm.dilID}
                    onChange={(e) => setDilForm({ ...dilForm, dilID: parseInt(e.target.value) })}
                  >
                    <option value="">Seçiniz</option>
                    {dilListesi.map((dil) => (
                      <option key={dil.dilId} value={dil.dilId}>{dil.dilAdi}</option>
                    ))}
                  </select>

                  <label>Okuma:</label>
                  <select
                    value={dilForm.okuma}
                    onChange={(e) => setDilForm({ ...dilForm, okuma: e.target.value })}
                  >
                    <option value="">Seçiniz</option>
                    {dilSeviyeListesi.map((seviye) => (
                      <option key={seviye.dilSeviyeId} value={seviye.dilSeviyeAdi}>{seviye.dilSeviyeAdi}</option>
                    ))}
                  </select>

                  <label>Yazma:</label>
                  <select
                    value={dilForm.yazma}
                    onChange={(e) => setDilForm({ ...dilForm, yazma: e.target.value })}
                  >
                    <option value="">Seçiniz</option>
                    {dilSeviyeListesi.map((seviye) => (
                      <option key={seviye.dilSeviyeId} value={seviye.dilSeviyeAdi}>{seviye.dilSeviyeAdi}</option>
                    ))}
                  </select>

                  <label>Konuşma:</label>
                  <select
                    value={dilForm.konusma}
                    onChange={(e) => setDilForm({ ...dilForm, konusma: e.target.value })}
                  >
                    <option value="">Seçiniz</option>
                    {dilSeviyeListesi.map((seviye) => (
                      <option key={seviye.dilSeviyeId} value={seviye.dilSeviyeAdi}>{seviye.dilSeviyeAdi}</option>
                    ))}
                  </select>

                  <label>Dinleme:</label>
                  <select
                    value={dilForm.dinleme}
                    onChange={(e) => setDilForm({ ...dilForm, dinleme: e.target.value })}
                  >
                    <option value="">Seçiniz</option>
                    {dilSeviyeListesi.map((seviye) => (
                      <option key={seviye.dilSeviyeId} value={seviye.dilSeviyeAdi}>{seviye.dilSeviyeAdi}</option>
                    ))}
                  </select>
                  {uyariGosterDil && (
                    <div className="warning-popup-bottom">{uyariGosterDil}</div>
                  )}

                  <div className="form-buttons">
                    <button className="cancel-btn" onClick={() => setShowDilPopup(false)}>Vazgeç</button>
                    <button className="submit-btn" onClick={handleAddDil}>
                      {duzenlenecekDil?.dilKullaniciId ? "Güncelle" : "Ekle"}
                    </button>
                  </div>


                </div>
              </div>
            )}

            {/* 🔹 Eklenen Diller */}
            <h4>Eklenen Diller:</h4>
            <div className="dil-liste-container">
              {eklenenDiller.length > 0 ? (
                <ul className="dil-liste">
                  {eklenenDiller.map((d, i) => (
                    <li key={i} className="kart-kapsayici" style={{ position: "relative" }}>
                      {/* Sağ üst: Sil butonu */}
                      <button
                        className="sil-btn-ikon"
                        onClick={() => {
                          setSilID(d.dilKullaniciId);
                          setShowDilDeleteConfirm(true);
                        }}
                      >
                        <img src="/images/delete.png" alt="sil" />
                      </button>

                      {/* Kart içeriği */}
                      <div className="kart-icerik">
                        <div><strong>Dil Adı:</strong> {getDilAdiById(d.dilId)}</div>
                        <div><strong>Okuma:</strong> {d.okuma || "-"}</div>
                        <div><strong>Yazma:</strong> {d.yazma || "-"}</div>
                        <div><strong>Konuşma:</strong> {d.konusma || "-"}</div>
                        <div><strong>Dinleme:</strong> {d.dinleme || "-"}</div>
                      </div>

                      {/* Sağ alt: Düzenle */}
                      <div className="kart-duzenle-btn">
                        <button
                          className="kalem-btn"
                          onClick={() => {
                            setDilForm({
                              dilID: d.dilId,
                              okuma: d.okuma,
                              yazma: d.yazma,
                              konusma: d.konusma,
                              dinleme: d.dinleme
                            });
                            setDuzenlenecekDil(d);
                            setShowDilPopup(true);
                          }}
                        >
                          ✏️
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="dil-bos-kutu">
                  <p><strong>Eklenen dil yok.</strong></p>
                </div>
              )}
            </div>

            {/* ➕ Sertifika Ekle Butonu */}
            <div className="ekle-btn-container">
              <button className="dil-ekle-btn" onClick={() => setShowSertifikaPopup(true)}>➕ Sertifika Ekle</button>
            </div>

            {/* ➕ Sertifika Popup */}
            {showSertifikaPopup && (
              <div className="modal-overlay" onClick={() => setShowSertifikaPopup(false)}>
                <div className="sertifika-modal-popup" onClick={(e) => e.stopPropagation()}>

                  <h3>Yeni Sertifika Ekle</h3>

                  <label>Sertifika Adı:</label>
                  <input
                    type="text"
                    value={sertifikaForm.ad}
                    onChange={(e) =>
                      setSertifikaForm({ ...sertifikaForm, ad: capitalizeText(e.target.value) })
                    }
                  />

                  <label>Açıklama:</label>
                  <input
                    type="text"
                    value={sertifikaForm.aciklama}
                    onChange={(e) =>
                      setSertifikaForm({ ...sertifikaForm, aciklama: capitalizeText(e.target.value) })
                    }
                  />

                  <div className="form-buttons">
                    <button className="cancel-btn" onClick={() => {
                      setShowSertifikaPopup(false);
                      setSertifikaForm({ ad: "", aciklama: "" });
                      setDuzenlenecekSertifika(null);
                    }}>
                      Vazgeç
                    </button>

                    <button className="submit-btn" onClick={handleAddSertifika}>
                      {duzenlenecekSertifika?.sertifikaID ? "Güncelle" : "Ekle"}
                    </button>
                  </div>

                </div>
              </div>
            )}

            {/* 🔹 Eklenen Sertifikalar */}
            <h4>Eklenen Sertifikalar:</h4>
            <div className="dil-liste-container">
              {eklenenSertifikalar.length > 0 ? (
                <ul className="sertifika-liste">
                  {eklenenSertifikalar.map((s, i) => (
                    <li key={i} className="kart-kapsayici" style={{ position: "relative" }}>
                      {/* Sağ üst: Sil */}
                      <button className="sil-btn-ikon" onClick={() => handleDeleteSertifika(s.sertifikaID)}>
                        <img src="/images/delete.png" alt="sil" />
                      </button>

                      {/* Kart içeriği */}
                      <div className="kart-icerik">
                        <div><strong>Sertifika Adı:</strong> {s.sertifikaAdi}</div>
                        <div><strong>Açıklama:</strong> {s.sertifikaAciklama}</div>
                      </div>

                      {/* Sağ alt: Düzenle */}
                      <div className="kart-duzenle-btn">
                        <button
                          className="kalem-btn"
                          onClick={() => {
                            setSertifikaForm({
                              ad: s.sertifikaAdi,
                              aciklama: s.sertifikaAciklama
                            });
                            setDuzenlenecekSertifika(s);
                            setShowSertifikaPopup(true);
                          }}
                        >
                          ✏️
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="dil-bos-kutu">
                  <p><strong>Eklenen sertifika yok.</strong></p>
                </div>
              )}
            </div>
          </div>
        )}


        {currentStep === 4 && (
          <div className="profil-onizleme-container">
            <h2>📄 Profil Ön İzleme</h2>

            {/* 👤 Genel Bilgiler */}
            <div className="profil-section">
              <h3 onClick={() => setCurrentStep(0)}>👤 Genel Bilgiler <span className="duzenle-link">(Düzenle)</span></h3>
              <p><strong>Ad Soyad:</strong> {formData.isim} {formData.soyisim}</p>
              <p><strong>Telefon:</strong> {formData.telefon}</p>
              <p><strong>Doğum Tarihi:</strong> {formData.dogumTarihi}</p>
              <p><strong>Cinsiyet:</strong> {formData.cinsiyet}</p>
              <p><strong>Adres:</strong> {formData.adres}</p>
              <p><strong>Şehir:</strong> {getIlAdi(parseInt(formData.KisiIlId))}</p>
              <p><strong>İlçe:</strong> {getIlceAdi(parseInt(formData.KisiIlceId))}</p>
              <p><strong>Maaş Beklentisi:</strong> {formData.maasBeklentisi || "-"} TL</p>
            </div>

            {/* 💼 Deneyimler */}
            {deneyimler.length > 0 && (
              <div className="profil-section">
                <h3 onClick={() => setCurrentStep(1)}>💼 Deneyimler <span className="duzenle-link">(Düzenle)</span></h3>
                {deneyimler.map((item, index) => (
                  <div key={index} className="profil-item">
                    <p><strong>Şirket:</strong> {item.sirketAdi}</p>
                    <p><strong>Pozisyon:</strong> {item.deneyimPozisyon}</p>
                    <p><strong>Süre:</strong> {item.baslangicTarihi?.slice(0, 10)} - {item.suanCalisiyorMu ? "Devam Ediyor" : item.bitisTarihi?.slice(0, 10)}</p>
                    <p><strong>Açıklama:</strong> {item.aciklama}</p>
                  </div>
                ))}
              </div>
            )}
            {referanslar.length > 0 && (
              <div className="profil-section">
                <h3>
                  Referanslar
                  <span
                    className="duzenle-link"
                    onClick={() => setCurrentStep(1)}
                  >
                    Düzenle
                  </span>
                </h3>
                {referanslar.map((r, index) => (
                  <div key={index} className="profil-item">
                    <p><strong>Adı:</strong> {r.referansAdi}</p>
                    <p><strong>Telefon:</strong> {r.referansNumara}</p>
                    <p><strong>Mail:</strong> {r.referansMail}</p>
                    <p><strong>Pozisyon:</strong> {r.referansPozisyon}</p>
                    <p><strong>Firma/Kurum:</strong> {r.referansFirmaKurum}</p>
                    <p><strong>Derece:</strong> {r.referansDerece}</p>
                    <p><strong>Açıklama:</strong> {r.referansAciklama}</p>
                    <p><strong>Tip:</strong> {r.profasyonelRefmi ? "Profesyonel" : "Kişisel"}</p>
                  </div>
                ))}
              </div>
            )}

            {/* 🎓 Eğitimler */}
            {egitimler.length > 0 && (
              <div className="profil-section">
                <h3 onClick={() => setCurrentStep(2)}>🎓 Eğitimler <span className="duzenle-link">(Düzenle)</span></h3>
                {egitimler.map((item, index) => {
                  const isLise = !!item.egitimLise;
                  return (
                    <div key={index} className="profil-item">
                      <p><strong>Kurum:</strong> {isLise ? item.egitimLise : getOkulAdi(item.egitimLisansID)}</p>
                      <p><strong>Bölüm:</strong> {isLise ? item.egitimLiseBolum : getBolumAdi(item.egitimBolumID)}</p>
                      <p><strong>Durum:</strong> {getEgitimDurumAdi(item.egitimDurumuID)}</p>
                      <p><strong>Bitiş Tarihi:</strong>{" "} {item.bitisTarihi ? new Date(item.bitisTarihi).toLocaleDateString("tr-TR", { month: "long", year: "numeric" }) : "-"}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}

            {/* 🌐 Yabancı Diller */}
            {eklenenDiller.length > 0 && (
              <div className="profil-section">
                <h3 onClick={() => setCurrentStep(3)}>🌐 Yabancı Diller <span className="duzenle-link">(Düzenle)</span></h3>
                {eklenenDiller.map((item, index) => (
                  <div key={index} className="profil-item">
                    <p><strong>Dil:</strong> {getDilAdi(item.dilId)}</p>
                    <p><strong>Okuma:</strong> {item.okuma || "-"}</p>
                    <p><strong>Yazma:</strong> {item.yazma || "-"}</p>
                    <p><strong>Konuşma:</strong> {item.konusma || "-"}</p>
                    <p><strong>Dinleme:</strong> {item.dinleme || "-"}</p>
                  </div>
                ))}
              </div>
            )}

            {/* 📜 Sertifikalar */}
            {eklenenSertifikalar.length > 0 && (
              <div className="profil-section">
                <h3 onClick={() => setCurrentStep(3)}>📜 Sertifikalar <span className="duzenle-link">(Düzenle)</span></h3>
                {eklenenSertifikalar.map((item, index) => (
                  <div key={index} className="profil-item">
                    <p><strong>Adı:</strong> {item.sertifikaAdi}</p>
                    <p><strong>Açıklama:</strong> {item.sertifikaAciklama}</p>
                  </div>
                ))}
              </div>
            )}

            {/* ✅ Doğrulamalar */}
            <div className="dogrulama-kutusu">
              {!telefonDogrulandi && (
                <div className="sms-dogrulama">
                  <input
                    type="text"
                    className="sms-kod-input"
                    placeholder="SMS'deki kodu girin"
                    value={smsKod}
                    onChange={(e) => setSmsKod(e.target.value.replace(/\D/g, "").slice(0, 6))}
                  />
                  <button
                    className={`kod-gonder-btn ${smsKodGonderildi ? "sms-dogrula" : ""}`}
                    onClick={async () => {

                      if (!formData.DogrulukBeyani) {
                        setProfilUyarisi("⚠️ Önce doğruluk beyanını onaylamalısınız.");
                        return;
                      }

                      if (!smsKodGonderildi) {
                        // 🔹 KOD GÖNDERME
                        try {
                          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/sendsmscode`, null, {
                            headers: {
                              Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                          });
                          gosterUyari("SMS kodu gönderildi.", "Gönderildi", "success");
                          setSmsKodGonderildi(true);
                        } catch (err) {
                          console.error("❌ Kod gönderme hatası:", err);
                          gosterUyari("SMS gönderilemedi.", "❌ Hata", "error");
                        }
                      } else {
                        // 🔹 KOD DOĞRULAMA
                        if (smsKod.length !== 6) {
                          setProfilUyarisi("⚠️ Lütfen 6 haneli bir kod girin.");
                          return;
                        }

                        try {
                          const res = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}/api/Auth/confirmsmscode`,
                            { code: smsKod },
                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                              },
                            }
                          );

                          if (res.status === 200 && typeof res.data === "string" && res.data.includes("doğrulandı")) {
                            setTelefonDogrulandi(true);
                            setProfilUyarisi("✅ Telefon numaranız başarıyla doğrulandı.");
                          } else {
                            setTelefonDogrulandi(false);
                            setProfilUyarisi("❌ Girilen SMS kodu hatalı.");
                          }
                        } catch (err) {
                          console.error("❌ SMS doğrulama hatası:", err);
                          setTelefonDogrulandi(false);
                          setProfilUyarisi("❌ Kod geçersiz veya süresi dolmuş. Lütfen tekrar deneyin.");
                        }
                      }
                    }}
                  >
                    {smsKodGonderildi ? "Kodu Doğrula" : "Kod Gönder"}
                  </button>
                </div>
              )}

              {/* ✅ Doğruluk Beyanı */}
              <div className="dogruluk-beyani-container">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.DogrulukBeyani || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setFormData((prev) => ({ ...prev, DogrulukBeyani: isChecked }));
                      setDogrulukBeyaniOnaylandi(isChecked);
                    }}
                  />
                  <span style={{ marginLeft: "8px" }}>
                    Bilgilerin doğruluğunu beyan ederim
                  </span>
                </label>
              </div>
            </div>

            {/* ⚠️ Uyarı Mesajı */}
            {profilUyarisi && (
              <div className="profil-uyari uyari-error">
                {profilUyarisi}
              </div>
            )}
          </div>
        )}

        <div className={`navigation-buttons ${currentStep === 0 ? "genel-sadece-devamet" : ""}`}>
          {currentStep > 0 && <button onClick={handleBack}>Geri Dön</button>}

          {currentStep < steps.length - 1 ? (
            <button onClick={handleNext}>Devam Et</button>
          ) : (
            <button
              onClick={async () => {
                // 🔸 SMS ve Beyan kontrolü
                if (!telefonDogrulandi) {
                  setProfilUyarisi("⚠️ Lütfen SMS doğrulaması yapın.");
                  return;
                }

                if (!formData.DogrulukBeyani) {
                  setProfilUyarisi("⚠️ Lütfen doğruluk beyanını onaylayın.");
                  return;
                }

                try {
                  const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/dogrulukbeyan`, null, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  });

                  if (
                    res.status === 200 ||
                    (res.response?.status === 400 && res.response?.data?.includes("Zaten kabul edilmiş"))
                  ) {
                    setProfilUyarisi("");
                    setDogrulukBeyaniOnaylandi(true);

                    setShowSuccessPopup(true);
                    setTimeout(() => {
                      setShowSuccessPopup(false);
                      navigate("/profil");
                    }, 3000);
                  } else {
                    setProfilUyarisi("❌ Doğruluk beyanı başarısız. Lütfen tekrar deneyin.");
                  }
                } catch (err) {
                  console.error("❌ Doğruluk beyanı hatası:", err);
                  if (
                    err.response?.status === 400 &&
                    err.response?.data?.includes("Zaten kabul edilmiş")
                  ) {
                    setDogrulukBeyaniOnaylandi(true);
                    setProfilUyarisi("");

                    setShowSuccessPopup(true);
                    setTimeout(() => {
                      setShowSuccessPopup(false);
                      navigate("/profil");
                    }, 3000);
                  } else {
                    setProfilUyarisi("❌ Doğruluk beyanı gönderilemedi.");
                  }
                }

              }}
            >
              Kaydet
            </button>
          )}
        </div>



        {showReferansPopup && (

          <div className="modal-overlay-referans" onClick={() => setShowReferansPopup(false)}>
            <div className="modal-popup-referans" onClick={(e) => e.stopPropagation()}>

              <h3>Yeni Referans Ekle</h3>

              <div className="referans-radio-options">
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="referansTipi"
                    checked={!referansForm.profosyonelRefmi}
                    onChange={() =>
                      setReferansForm({ ...referansForm, profosyonelRefmi: false })
                    }
                  />
                  <span>Kişisel Referans</span>
                </label>

                <label className="radio-inline">
                  <input
                    type="radio"
                    name="referansTipi"
                    checked={referansForm.profosyonelRefmi}
                    onChange={() =>
                      setReferansForm({ ...referansForm, profosyonelRefmi: true })
                    }
                  />
                  <span>Profesyonel Referans</span>
                </label>
              </div>
              <br></br>
              <label>Adı Soyadı :</label>
              <input
                type="text"
                value={referansForm.referansAdi}
                onChange={(e) =>
                  setReferansForm({ ...referansForm, referansAdi: capitalizeText(e.target.value) })
                }
              />


              <label>Çalıştığı Firma / Kurum :</label>
              <input
                type="text"
                value={referansForm.referansFirmaKurum}
                onChange={(e) =>
                  setReferansForm({ ...referansForm, referansFirmaKurum: capitalizeText(e.target.value) })
                }
              />

              <label>Pozisyonu :</label>
              <input
                type="text"
                value={referansForm.referansPozisyon}
                onChange={(e) =>
                  setReferansForm({ ...referansForm, referansPozisyon: capitalizeText(e.target.value) })
                }
              />

              <label>Yakınlık Derecesi:</label>
              <select
                value={referansForm.referansDerece}
                onChange={(e) =>
                  setReferansForm({ ...referansForm, referansDerece: e.target.value })
                }
              >
                <option value="">Seçiniz</option>
                {(referansForm.profosyonelRefmi ? profesyonelDereceler : kisiselDereceler).map(
                  (secenek, i) => (
                    <option key={i} value={secenek}>
                      {secenek}
                    </option>
                  )
                )}
              </select>

              <label>Telefon Numarası :</label>
              <input
                type="tel"
                value={referansForm.referansNumara}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10); // sadece rakam, max 10 hane
                  const masked =
                    value.length <= 3
                      ? value
                      : value.length <= 6
                        ? `${value.slice(0, 3)} ${value.slice(3)}`
                        : value.length <= 8
                          ? `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6)}`
                          : `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6, 8)} ${value.slice(8)}`;
                  setReferansForm((prev) => ({ ...prev, referansNumara: masked }));
                }}
              />

              <label>E-posta :</label>
              <input
                type="email"
                value={referansForm.referansMail}
                onChange={(e) => setReferansForm({ ...referansForm, referansMail: e.target.value })}
              />
              <label>Açıklama :</label>
              <textarea
                value={referansForm.referansAciklama}
                onChange={(e) =>
                  setReferansForm({ ...referansForm, referansAciklama: capitalizeText(e.target.value) })
                }
              />

              {referansKaydetClicked && referansUyari && (
                <div className="warning-popup-bottom">{referansUyari}</div>
              )}
              <div className="form-buttons">
                <button className="cancel-btn" onClick={() => setShowReferansPopup(false)}>Vazgeç</button>
                <button className="submit-btn" onClick={handleReferansKaydet}>
                  {referansForm.referansId ? "Güncelle" : "Ekle"}
                </button>
              </div>

            </div>
          </div>
        )}

        {uyariAcik && (
          <UyariPopup
            title={uyariBaslik}
            message={uyariMesaj}
            type={uyariTipi}
            onClose={() => setUyariAcik(false)}
          />
        )}

        {showSuccessPopup && (
          <div className="popup-success">
            <div className="checkmark"></div>
            <h3>Özgeçmiş başarıyla kayıt edildi</h3>
          </div>
        )}
      </div>

      {showKvkkModal && (
        <div className="modal-overlay-kvkk" onClick={() => setShowKvkkModal(false)}>
          <div className="modal-content-kvkk" onClick={(e) => e.stopPropagation()}>
            <button className="close-button-kvkk" onClick={() => setShowKvkkModal(false)}>✖</button>
            <h2 className="kvkk-title">KVKK Onay Metni</h2>
            <div className="kvkk-body">
              <p><strong>KİŞİSEL VERİLERİN İŞLENMESİ VE GÜVENLİĞİ ONAY FORMU</strong></p>
              <p>Bu dokumanı onaylayarak 6698 Sayılı Kişisel Verilerin Korunması Kanunu’nun (“Kanun”) 5. Maddesi kapsamında Şirketimize iletmiş olduğunuz kişisel verilerinizin, hizmetlerimiz hakkında bilgi vermek ve sizlerle iletişime geçmek, istatistiki bilgi toplamak ve bu işlemlerin yapılması amacıyla verileri yurtiçi ve yurtdışında yerleşik üçüncü kişilere aktarmak maksadıyla Şirketimiz tarafından işlenmesine açıkça rıza göstermektesiniz...</p>

              <p>Kişisel Verilerinizin, Veri Sorumlusu şahsın/Şirketimizin belirleyeceği yurtiçi veya yurtdışında bulunan 3. kişilere işbu verilerin saklanması, depolanması ve açık rıza gösterilen amaçlarla işlenmesi için aktarılmasına açıkça onay vermektesiniz...</p>

              <p>Kanuni haklarınız kapsamında; dilediğiniz zaman Veri Sorumlusu Şirketimize başvurarak tarafınıza ait kişisel verilerin işlenip işlenmediğini öğrenme... zararını yasalar çerçevesinde talep etme hakkınız mevcuttur.</p>

              <p><strong>
                Musa Dengiz Tekstil Sanayi ve Ticaret Limited Şirketi tarafından açıklanan 6698 sayılı Kişisel Verilerin Korunması Kanunu’na ilişkin aydınlatma metninin tamamını okudum, anladım ve Musa Dengiz Tekstil Sanayi ve Ticaret Limited Şirketi’nin Kişisel Verilerimi yukarıda belirtilen amaçlar çerçevesinde işlemesi konusunda bilgilendirildim...
              </strong></p>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Deneyim Silme */}
      {showDeleteConfirm && (
        <div className="modal-overlay" onClick={() => setShowDeleteConfirm(false)}>
          <div className="delete-confirm-popup" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">Bu deneyimi silmek istediğine emin misin?</h3>
            <p className="popup-message">Bu işlem geri alınamaz.</p>
            <div className="popup-buttons">
              <button className="btn-cancel" onClick={() => setShowDeleteConfirm(false)}>Vazgeç</button>
              <button className="btn-delete" onClick={handleDeleteOnayla}>Evet, Sil</button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Eğitim Silme */}
      {showEgitimDeleteConfirm && (
        <div className="modal-overlay" onClick={() => setShowEgitimDeleteConfirm(false)}>
          <div className="delete-confirm-popup" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">Bu eğitimi silmek istediğine emin misin?</h3>
            <p className="popup-message">Bu işlem geri alınamaz.</p>
            <div className="popup-buttons">
              <button className="btn-cancel" onClick={() => setShowEgitimDeleteConfirm(false)}>Vazgeç</button>
              <button className="btn-delete" onClick={handleEgitimSilOnayla}>Evet, Sil</button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Dil Silme */}
      {showDilDeleteConfirm && (
        <div className="modal-overlay" onClick={() => setShowDilDeleteConfirm(false)}>
          <div className="delete-confirm-popup" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">Bu dili silmek istediğine emin misin?</h3>
            <p className="popup-message">Bu işlem geri alınamaz.</p>
            <div className="popup-buttons">
              <button className="btn-cancel" onClick={() => setShowDilDeleteConfirm(false)}>Vazgeç</button>
              <button className="btn-delete" onClick={handleDeleteDil}>Evet, Sil</button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Sertifika Silme */}
      {showSertifikaDeleteConfirm && (
        <div className="modal-overlay" onClick={() => setShowSertifikaDeleteConfirm(false)}>
          <div className="delete-confirm-popup" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">Bu sertifikayı silmek istediğine emin misin?</h3>
            <p className="popup-message">Bu işlem geri alınamaz.</p>
            <div className="popup-buttons">
              <button className="btn-cancel" onClick={() => setShowSertifikaDeleteConfirm(false)}>Vazgeç</button>
              <button className="btn-delete" onClick={handleSertifikaSilOnayla}>Evet, Sil</button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Referans Silme */}
      {showReferansDeleteConfirm && (
        <div className="modal-overlay" onClick={() => setShowReferansDeleteConfirm(false)}>
          <div className="delete-confirm-popup" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">Bu referansı silmek istediğine emin misin?</h3>
            <p className="popup-message">Bu işlem geri alınamaz.</p>
            <div className="popup-buttons">
              <button className="btn-cancel" onClick={() => setShowReferansDeleteConfirm(false)}>Vazgeç</button>
              <button className="btn-delete" onClick={handleReferansSilOnayla}>Evet, Sil</button>
            </div>
          </div>
        </div>
      )}

      {showCropper && (
        <CropperPopup
          image={cropImageUrl}
          onCancel={() => setShowCropper(false)}
          onCropComplete={async (croppedBlob) => {
            if (fotoKaydediliyor) return;

            setFotoKaydediliyor(true);
            setWarning("Profil fotoğrafı kaydediliyor, lütfen bekleyin...");

            const formData = new FormData();
            formData.append("Foto", croppedBlob, "pp.jpg");

            try {
              await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppyukle`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              await fetchPhoto();
              setShowCropper(false);
              setWarning("");
              gosterUyari("Profil fotoğrafı başarıyla kaydedildi.", "✅ Başarılı", "success");
            } catch (err) {
              console.error("❌ Fotoğraf yüklenemedi:", err);
              setWarning("❌ Fotoğraf kaydedilirken hata oluştu.");
            } finally {
              setFotoKaydediliyor(false);
            }
          }}
        />
      )}

      {showFullPhoto && (
        <div className="photo-modal-overlay" onClick={() => setShowFullPhoto(false)}>
          <div className="photo-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={profilePhoto} alt="Büyük Profil" />
            <span className="photo-modal-close" onClick={() => setShowFullPhoto(false)}>✖</span>
          </div>
        </div>
      )}

    </div>
  );
};

export default Ozgecmisim;
